"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgFrontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "100%"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M.014.017h4.624v2.648H.014z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    d: "M.058 0h42.716v27.741H.058z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    d: "M.05 0h28.779v2.64H.049z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Auto/compacto/Frontal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1104-Copy",
    transform: "translate(17 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.035 20.118V31.86c-.035.366-.13.553-.426.783-.13.207-.482.352-.925.434v-.09a4.55 4.55 0 01-.14.023v.09a5.524 5.524 0 01-.76.059v-.091h-.156v.09a5.535 5.535 0 01-.758-.061v-.09a4.422 4.422 0 01-.14-.024v.09c-.44-.083-.79-.227-.92-.43-.297-.23-.39-.417-.427-.783V20.118c.036-.365.13-.553.427-.783.129-.206.48-.35.92-.433v.09l.14-.023v-.09c.238-.037.497-.056.758-.06v.092h.157v-.091c.26.004.52.024.759.06v.09l.14.024v-.09c.442.084.794.227.925.431.296.23.39.418.426.783",
    id: "Fill-1",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(5.383 30.47)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.638.017v1.25c-.036.394-.13.595-.424.843-.128.223-.479.379-.919.467V2.48a8.508 8.508 0 01-.14.025v.096c-.237.04-.495.06-.754.063v-.098h-.156v.098a5.103 5.103 0 01-.754-.066v-.097a4.05 4.05 0 01-.139-.026v.096C.915 2.483.567 2.33.438 2.11c-.295-.248-.389-.45-.424-.843V.017c.176 1.948 4.463 1.776 4.624 0",
    id: "Fill-3",
    fill: "#131313",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.733 32.886c.274-.112.32-.166.43-.293v-.011c-.118.16-.216.205-.43.304zm0-.108c.274-.108.32-.16.43-.283v-.022c-.118.16-.216.205-.43.305zm0-.175c.274-.103.32-.152.43-.271v-.031c-.118.157-.216.202-.43.302zm0-.24c.274-.095.32-.142.43-.255v-.04c-.118.153-.216.198-.43.295zm0-.298c.274-.088.32-.132.43-.238v-.05c-.118.149-.216.192-.43.288zm0-.356c.274-.08.32-.12.43-.218v-.058c-.118.143-.216.185-.43.276zm0-.407c.274-.071.32-.108.43-.197v-.066c-.118.135-.216.175-.43.263zm0-.457v.003c.274-.064.32-.097.43-.177V30.6c-.118.126-.216.163-.43.246zm0-.503v.005c.273-.056.322-.086.43-.153v-.079c-.118.116-.216.15-.43.227zm0-.544v.005c.273-.045.322-.07.43-.126v-.085c-.118.104-.216.136-.43.206zm0-.582v.005c.273-.034.322-.054.43-.099v-.09c-.118.092-.215.12-.43.184zm0-.616v.004c.273-.022.322-.036.43-.069v-.095c-.118.079-.215.104-.43.16zm0-.648v.006c.273-.01.322-.02.43-.04v-.1c-.117.065-.215.087-.43.134zm0-.668v.006c.271.001.328-.003.43-.01v-.11c-.117.054-.215.073-.43.114zm0-.696v.007l.43.025v-.12c-.117.04-.215.056-.43.088zm0-.723v.007c.276.03.327.04.43.06v-.12c-.111.021-.206.031-.43.053zm0-.721v.006c.275.043.32.058.43.095v-.12l-.43.019zm0-.7v.007c.275.049.32.068.43.113v-.104a4.103 4.103 0 00-.43-.015zm0-.671v.005c.274.06.32.083.43.14v-.099c-.119-.03-.216-.034-.43-.046zm0-.643v.005c.274.07.32.098.43.166v-.095c-.118-.044-.216-.054-.43-.076zm0-.61v.005c.274.077.32.11.43.189v-.09c-.118-.06-.216-.073-.43-.104zm0-.575v.005c.274.086.32.123.43.211v-.083c-.118-.074-.216-.092-.43-.133zm0-.535v.005c.274.093.32.134.43.231v-.078c-.118-.087-.216-.109-.43-.158zm0-.492v.004c.274.1.32.144.43.25v-.07c-.118-.1-.216-.127-.43-.184zm0-.445c.274.11.32.156.43.269v-.064c-.118-.11-.216-.14-.43-.205zm0-.395c.274.113.32.163.43.281v-.055c-.118-.122-.216-.155-.43-.226zm0-.342c.274.117.32.168.43.292v-.047c-.118-.131-.216-.167-.43-.245zm0-.285c.274.12.32.172.43.3v-.039c-.118-.14-.216-.177-.43-.26zm0-.224c.274.12.32.174.43.304v-.029c-.118-.146-.216-.186-.43-.275zm0-.16c.274.12.32.174.43.306v-.02c-.118-.151-.216-.193-.43-.286zm.075-.059a.796.796 0 01.354.271v-.009c-.102-.136-.19-.187-.354-.262zm-.064-.012zM4.453 32.578v.011c.113.157.21.201.421.297-.27-.12-.314-.174-.421-.308zm0-.108v.021c.113.153.21.195.421.288-.27-.121-.314-.176-.421-.31zm0-.173v.032c.113.146.21.186.421.275-.27-.12-.314-.175-.421-.307zm0-.233v.041c.113.14.21.177.421.26-.27-.119-.314-.172-.421-.3zm0-.29v.05c.113.13.21.166.421.243-.27-.117-.314-.168-.421-.293zm0-.343v.057c.113.121.21.153.421.224-.27-.113-.314-.162-.421-.281zm0-.394v.065c.113.11.21.139.421.203-.27-.109-.314-.155-.421-.268zm0-.44v.072c.113.098.21.123.421.18v-.005c-.27-.099-.314-.142-.421-.247zm0-.484v.079c.113.085.21.107.421.154v-.004c-.27-.092-.314-.132-.421-.229zm0-.523v.085c.113.071.21.089.421.128v-.005c-.27-.084-.314-.12-.421-.208zm0-.56v.09c.113.058.21.071.421.1v-.004c-.27-.076-.314-.108-.421-.186zm0-.592v.096c.113.042.21.05.421.07V28.6c-.27-.066-.314-.094-.421-.16zm0-.62v.099c.114.026.21.03.421.04v-.005c-.27-.057-.314-.08-.421-.135zm0-.648v.11c.115.01.223.01.421.01v-.007c-.27-.049-.315-.068-.421-.113zm0-.67v.12l.421-.025v-.006c-.27-.04-.315-.054-.421-.088zm0-.687v.119c.107-.024.2-.036.421-.06v-.006a4.19 4.19 0 01-.421-.053zm0-.687v.12c.112-.044.209-.06.421-.095v-.007c-.256-.012-.322-.014-.421-.018zm0-.665v.103c.112-.054.21-.073.421-.113v-.006a3.561 3.561 0 00-.421.016zm0-.64v.098c.112-.069.21-.091.421-.14v-.006a1.94 1.94 0 00-.421.047zm0-.613v.094c.113-.083.21-.109.421-.167v-.005c-.27.025-.317.042-.421.078zm0-.582v.09c.113-.096.21-.126.421-.191v-.005c-.27.036-.317.058-.421.106zm0-.546v.083c.113-.108.21-.14.421-.213v-.005c-.27.048-.317.075-.421.135zm0-.51v.078c.113-.119.21-.154.421-.233v-.004c-.27.057-.314.087-.421.16zm0-.466v.07c.113-.129.21-.167.421-.251v-.004c-.27.067-.314.102-.421.185zm0-.423v.063c.113-.137.21-.178.421-.267v-.004c-.27.077-.314.115-.421.208zm0-.374v.055c.113-.145.21-.188.421-.281-.27.082-.314.124-.421.226zm0-.323v.047c.113-.151.21-.195.421-.292-.27.09-.314.135-.421.245zm0-.269v.039c.113-.156.21-.202.421-.3-.27.097-.314.145-.421.261zm0-.21v.03c.113-.16.21-.206.421-.306-.27.104-.314.154-.421.277zm0-.148v.02c.113-.162.21-.208.421-.309-.27.11-.314.162-.421.29zm0-.083v.008c.113-.16.21-.207.421-.307-.27.114-.314.168-.421.299zm3.705-.037l.012.014a.531.531 0 00-.104-.11.973.973 0 01.04.042.72.72 0 00.016.015l.008.009a.502.502 0 01.045.055v-.004l-.017-.021zm-1.655-.342a.179.179 0 00.084-.01c.13-.042.312-.07.537-.03v-.013a1.167 1.167 0 00-.621.053zm0 .135l.029.006c.203-.067.404-.097.592-.097v-.022a1.67 1.67 0 00-.53.078l-.091.035zm.066.196c.18-.068.37-.108.555-.121v-.028c-.2.016-.412.066-.621.158a.137.137 0 00.066-.009zm-.066.298a.115.115 0 00.066-.011c.063-.03.141-.068.268-.108.1-.028.196-.048.287-.061v-.036a1.865 1.865 0 00-.227.047c-.19.06-.253.091-.394.17zm.084.324c.173-.1.357-.169.537-.208v-.042a1.908 1.908 0 00-.621.274c.025.007.061-.011.084-.024zm-.055.436a2.21 2.21 0 01.592-.286v-.05c-.204.063-.417.17-.621.328l.029.008zm0 .457c.207-.157.407-.264.592-.332v-.058a2.156 2.156 0 00-.621.38l.029.01zm0 .504c.207-.173.407-.294.592-.374v-.066c-.2.09-.411.229-.621.43l.029.01zm0 .548c.21-.19.409-.326.592-.417v-.068a2.45 2.45 0 00-.621.474l.029.011zm-.029.578l.029.012c.21-.205.409-.352.592-.454v-.075a2.635 2.635 0 00-.621.517zm0 .626l.029.012c.165-.17.195-.202.305-.29.1-.077.196-.142.287-.196v-.081a2.728 2.728 0 00-.621.555zm0 .66l.029.013c.214-.234.412-.404.592-.523v-.083a3.045 3.045 0 00-.621.593zm0 .69l.029.013a3.55 3.55 0 01.592-.552v-.086a3.155 3.155 0 00-.621.625zm0 .716l.029.013c.213-.253.411-.441.592-.579v-.087a3.374 3.374 0 00-.621.653zm0 .739l.029.014c.212-.261.411-.458.592-.602v-.091a3.6 3.6 0 00-.621.679zm0 .74l.029.014c.217-.262.415-.46.592-.607v-.095a4.006 4.006 0 00-.621.689zm0 .721l.029.013a4.81 4.81 0 01.592-.595v-.094c-.191.165-.4.385-.621.676zm0 .697l.029.012c.216-.246.414-.435.592-.58v-.09a4.331 4.331 0 00-.621.658zm0 .67l.029.01c.218-.238.416-.42.592-.562v-.086c-.19.158-.4.366-.621.637zm0 .637l.029.01c.218-.225.415-.401.592-.54v-.083a4.972 4.972 0 00-.621.613zm0 .602c.009.003.02.008.029.01.217-.213.415-.382.592-.516v-.078c-.192.15-.402.34-.621.584zm.029.573c.216-.2.414-.36.592-.49v-.073c-.192.146-.401.327-.621.554l.029.01zm0 .52c.136-.116.333-.283.592-.46v-.066c-.193.14-.403.31-.621.518l.029.008zm0 .474c.224-.174.415-.31.592-.426v-.063c-.282.19-.471.353-.621.481l.029.008zm-.029.417l.029.006c.333-.23.39-.269.592-.39v-.055a6.212 6.212 0 00-.621.439zm.029.376l.592-.332v-.066a8.567 8.567 0 00-.621.393c.009.001.02.009.029.005zm.592.018v-.051c-.208.108-.208.108-.621.34.013.003.038.006.62-.29zm0 .306v-.048c-.174.08-.378.174-.621.283.057.006.32-.097.62-.235zm0 .224v-.026c-.301.118-.561.204-.621.224.042.002.31-.08.62-.198zm0 .169v-.02a6.443 6.443 0 01-.621.167c.053 0 .316-.055.62-.147zm0 .104v-.012a3.25 3.25 0 01-.621.119c.175-.007.396-.045.62-.107zm.04.059l-.024.003.024-.003zm.85-14.003c-.184-.137-.46-.228-.751-.27v.008c.09.013.187.03.288.056a1.4 1.4 0 01.462.206zm-.751-.185v.018c.433.027.779.183.902.387v-.016c-.154-.235-.518-.363-.902-.389zm0 .15v.029c.406-.001.767.126.902.356v-.027c-.138-.217-.485-.361-.902-.359zm0 .223v.033c.469-.037.783.117.902.322v-.039c-.158-.252-.528-.341-.902-.316zm0 .278v.043c.401-.055.762.042.902.285v-.048c-.142-.228-.493-.34-.902-.28zm0 .34v.05c.446-.092.784.04.902.246v-.059c-.144-.23-.495-.325-.902-.238zm0 .392v.061c.444-.12.782-.003.902.202V20.5c-.13-.204-.472-.316-.902-.196zm0 .447v.067c.442-.147.78-.046.902.157V20.9c-.135-.206-.482-.292-.902-.15zm0 .493v.07c.451-.18.782-.079.902.116v-.084c-.134-.197-.477-.275-.902-.102zm0 .537v.077c.45-.204.78-.12.902.068v-.09c-.115-.163-.454-.261-.902-.055zm0 .582v.083c.454-.227.775-.172.902.015v-.097c-.123-.164-.469-.223-.902-.001zm0 .613v.085c.479-.267.802-.167.902-.029v-.103c-.118-.148-.458-.207-.902.047zm0 .653v.087c.476-.29.8-.21.902-.08v-.11c-.127-.144-.474-.162-.902.103zm0 .68v.09c.473-.31.798-.252.902-.131v-.114c-.108-.112-.454-.14-.902.156zm0 .707v.093c.47-.327.796-.293.902-.184v-.117c-.11-.102-.456-.107-.902.208zm0 .726v.098c.506-.373.814-.315.902-.235v-.121c-.097-.078-.438-.087-.902.258zm0 .733v.098c.515-.378.828-.332.902-.277v-.121c-.101-.066-.438-.052-.902.3zm0 .717v.093c.51-.372.827-.357.902-.314v-.118c-.1-.048-.443-.005-.902.339zm0 .69v.09c.591-.428.898-.35.902-.348v-.114c-.068-.02-.41.005-.902.372zm0 .664v.088c.584-.416.898-.382.902-.381v-.11c-.005 0-.352-.002-.902.403zm0 .716c.58-.405.897-.408.902-.408v-.104c-.005 0-.37.052-.902.43v.082zm0 .593c.562-.383.883-.43.902-.432v-.098c-.005 0-.369.079-.902.453v.077zm0 .554c.217-.139.47-.28.763-.404.041-.017.041-.017.139-.048v-.092c-.055.018-.409.138-.902.473v.071zm0 .513c.302-.186.57-.315.902-.47v-.084a8.03 8.03 0 00-.902.488v.066zm0 .467c.297-.167.611-.301.902-.483v-.077c-.294.18-.605.327-.902.501v.06zm0 .364v.066l.902-.505v-.068c-.054.04-.054.04-.845.475l-.057.032zm0 .423l.562-.29a1.74 1.74 0 00.34-.212v-.06c-.106.093-.111.098-.902.51v.052zm0 .313c.39-.185.804-.405.902-.509v-.05c-.092.092-.163.164-.902.51v.049zm0 .206v.027c.375-.15.774-.34.902-.49v-.04c-.15.166-.538.353-.902.503zm0 .185v.021c.183-.06.373-.133.535-.214.162-.081.295-.17.367-.264v-.03c-.156.192-.538.362-.902.487zm0 .122v.011c.386-.104.758-.266.902-.462v-.018c-.159.21-.531.367-.902.469zm0 .052c.139-.027.319-.072.486-.143.169-.07.325-.167.416-.297v-.006c-.183.256-.615.385-.902.446zM5.489 18.838v.013c.184-.03.369-.02.535.031l.056.019.029-.007a1.158 1.158 0 00-.62-.056zm0 .073v.022c.162 0 .33.021.493.067l.098.03.029-.005a1.848 1.848 0 00-.62-.114zm0 .164v.026a2.027 2.027 0 01.591.139l.029-.006a1.959 1.959 0 00-.62-.16zm.333.313a2.11 2.11 0 00-.333-.08v.031a1.944 1.944 0 01.554.173l.037.018.029-.006a1.627 1.627 0 00-.287-.136zm-.333.209v.042a1.923 1.923 0 01.591.24l.029-.007a1.906 1.906 0 00-.62-.275zm0 .349v.048c.178.053.366.14.554.265l.037.025.029-.009a1.989 1.989 0 00-.62-.329zm0 .402v.057c.178.065.366.166.554.307l.037.028.029-.01a2.172 2.172 0 00-.62-.382zm0 .456v.063c.178.077.367.19.554.346.01.01.026.022.037.031l.029-.01a2.22 2.22 0 00-.62-.43zm0 .507v.065a2.424 2.424 0 01.591.417l.029-.01a2.394 2.394 0 00-.62-.472zm0 .541v.075a2.471 2.471 0 01.591.455l.029-.011a2.652 2.652 0 00-.62-.519zm0 .588v.078c.057.035.116.072.174.114.197.152.262.217.38.338.01.012.026.027.037.039l.029-.012a2.742 2.742 0 00-.62-.557zm0 .626v.083c.177.116.365.273.554.48l.037.04.029-.012a2.987 2.987 0 00-.62-.591zm0 .655v.085c.172.121.354.282.535.49.017.019.04.044.056.064l.029-.013a3.164 3.164 0 00-.62-.626zm0 .687v.089c.17.125.34.282.493.462l.098.117.029-.013a3.4 3.4 0 00-.62-.655zm0 .713v.092c.176.14.363.323.554.556l.037.047.029-.014a3.624 3.624 0 00-.62-.681zm0 .731v.098c.171.14.358.325.554.56l.037.046.029-.013a4.04 4.04 0 00-.62-.691zm0 .738v.09c.162.132.33.292.493.48l.098.116.029-.013c-.22-.29-.429-.509-.62-.673zm0 .712v.088c.159.127.325.283.493.47l.098.112.029-.012a4.37 4.37 0 00-.62-.658zm0 .69v.085c.17.136.357.308.554.523l.037.04.029-.01a4.652 4.652 0 00-.62-.639zm0 .662v.082c.171.134.358.299.554.503l.037.039.029-.011a5.004 5.004 0 00-.62-.613zm0 .631v.077c.17.127.355.285.554.48.01.012.026.027.037.038l.029-.01a4.94 4.94 0 00-.62-.585zm0 .595v.07c.166.121.347.266.535.441l.056.051.029-.009a5.468 5.468 0 00-.62-.553zm0 .557v.065a6.31 6.31 0 01.591.46l.029-.008a6.09 6.09 0 00-.62-.517zm0 .51v.064a7.464 7.464 0 01.591.425l.029-.007a5.985 5.985 0 00-.62-.482zm0 .468v.056a7.44 7.44 0 01.554.363l.037.026.029-.007a6.799 6.799 0 00-.62-.438zm0 .418v.05c.093.051.147.08.22.123l.334.2c.01.008.026.017.037.023l.029-.005a8.86 8.86 0 00-.62-.391zm0 .364v.044l.554.281.037.02.029-.005a17.374 17.374 0 00-.62-.34zm0 .31v.035c.153.067.33.143.535.227l.056.023.029-.003a52.147 52.147 0 01-.62-.282zm0 .245v.024c.3.113.548.189.554.19l.037.011.029-.002c-.06-.02-.32-.105-.62-.223zm0 .177v.018c.201.062.393.11.535.137l.056.01h.029a6.245 6.245 0 01-.62-.165zm0 .11v.013c.205.056.399.09.54.102l.051.004h.029a3.177 3.177 0 01-.62-.119zm-1.036-.431v.006c.178.262.62.388.898.444-.286-.062-.719-.191-.898-.45zm0-.075v.018c.15.21.528.366.898.465v-.012c-.371-.102-.743-.26-.898-.47zm0-.14v.03c.13.18.516.353.898.48v-.019c-.363-.124-.743-.294-.898-.49zm0-.202v.04c.136.167.534.35.898.493v-.027c-.364-.15-.752-.337-.898-.506zm0-.26v.05c.04.044.15.162.898.5v-.038c-.737-.346-.81-.422-.898-.513zm0-.317v.06c.074.07.087.083.898.497v-.045c-.783-.407-.789-.412-.898-.512zm.84.11c-.774-.427-.774-.427-.84-.478v.068c.084.068.28.17.489.277.107.056.248.13.41.217v-.052a7.28 7.28 0 00-.059-.033zm-.48-.693a5.622 5.622 0 01-.36-.202v.077c.287.187.602.318.898.485v-.059c-.147-.087-.32-.184-.538-.301zm-.36-.663v.085c.243.113.543.252.898.471v-.066a9.519 9.519 0 00-.898-.49zm0-.503v.092l.117.04c.2.086.466.211.781.414v-.07c-.488-.331-.843-.457-.898-.476zm0-.54v.098c.09.012.43.12.898.433v-.076c-.53-.373-.893-.454-.898-.455zm0-.575v.104c.084-.003.415.073.898.409v-.08c-.53-.38-.894-.433-.898-.433zm0-.606v.109c.114-.024.447.062.898.382v-.088c-.548-.405-.894-.404-.898-.403zm0-.634v.114c.11-.043.441.02.898.35v-.091c-.49-.367-.832-.394-.898-.373zm0-.657v.118c.135-.077.48.015.898.315v-.093c-.458-.345-.8-.388-.898-.34zm0-.678v.12c.148-.11.498-.009.898.28v-.095c-.463-.35-.803-.368-.898-.305zm0-.691v.121c.113-.105.446-.088.898.24v-.103c-.463-.347-.803-.337-.898-.258zm0-.676v.117c.13-.14.474-.107.898.186v-.095c-.445-.317-.79-.31-.898-.208zm0-.654v.114c.152-.182.516-.107.898.135v-.093c-.448-.298-.792-.269-.898-.156zm0-.627v.109c.128-.17.477-.168.898.082v-.09c-.428-.266-.773-.248-.898-.101zm0-.598v.103c.124-.18.472-.198.898.035v-.087c-.455-.257-.796-.182-.898-.05zm0-.565v.097c.144-.217.497-.215.898-.017v-.082c-.433-.223-.777-.163-.898.002zm0-.529v.091c.134-.217.488-.248.898-.066v-.08c-.448-.208-.786-.108-.898.055zm0-.489v.084c.134-.223.482-.278.898-.115v-.067c-.419-.17-.765-.103-.898.098zm0-.446v.075c.132-.226.48-.299.898-.16v-.066c-.42-.144-.766-.057-.898.15zm0-.4v.067c.129-.23.478-.32.898-.206v-.058c-.43-.122-.771-.009-.898.197zm0-.35v.058c.127-.231.476-.338.898-.25v-.049c-.407-.088-.757.008-.898.24zm0-.298v.048c.134-.245.495-.342.898-.285v-.045c-.409-.06-.759.052-.898.282zm0-.242v.039c.133-.236.482-.356.898-.325v-.03c-.409-.032-.755.081-.898.316zm0-.181v.027c.133-.236.49-.365.898-.36v-.028c-.417-.003-.763.142-.898.36zm0-.119v.016c.129-.223.486-.366.898-.392v-.019c-.422.026-.764.184-.898.395zm0-.052v.004c.139-.226.505-.369.898-.422v-.005c-.39.054-.75.198-.898.423z",
    id: "Fill-6",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 18.844v14.29l.127.025v-14.34a3.304 3.304 0 00-.126.025",
    id: "Fill-8",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 18.82v14.339l.127-.024V18.844a3.424 3.424 0 00-.127-.024",
    id: "Fill-10",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18 18.82v14.338h.127V18.82h-.126",
    id: "Fill-12",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.392 20.118V31.86c-.036.366-.13.553-.427.783-.129.207-.482.352-.924.434v-.09a4.55 4.55 0 01-.141.023v.09a5.524 5.524 0 01-.759.059v-.091h-.156v.09a5.533 5.533 0 01-.759-.061v-.09a4.422 4.422 0 01-.14-.024v.09c-.44-.083-.79-.227-.92-.43-.296-.23-.39-.417-.426-.783V20.118c.035-.365.13-.553.426-.783.129-.206.48-.35.92-.433v.09l.14-.023v-.09c.239-.037.498-.056.759-.06v.092h.156v-.091c.261.004.52.024.759.06v.09l.14.024v-.09c.442.084.794.227.925.431.297.23.39.418.427.783",
    id: "Fill-14",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.392 30.47v1.27c-.036.399-.13.603-.427.856-.129.225-.482.384-.924.473v-.098a7.257 7.257 0 01-.14.026v.098c-.24.04-.499.06-.76.064v-.1h-.157v.1a5.087 5.087 0 01-.758-.068v-.098a4.018 4.018 0 01-.14-.026v.098c-.44-.091-.79-.248-.92-.47-.296-.252-.39-.456-.426-.855v-1.27c.177 1.978 4.49 1.803 4.652 0",
    id: "Fill-16",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.95 32.886c.274-.112.32-.166.43-.293v-.011c-.118.16-.215.205-.43.304zm0-.108c.274-.108.32-.16.43-.283v-.022c-.118.16-.215.205-.43.305zm0-.175c.274-.103.32-.152.43-.271v-.031c-.118.157-.215.202-.43.302zm0-.24c.274-.095.32-.142.43-.255v-.04c-.118.153-.215.198-.43.295zm0-.298c.274-.088.32-.132.43-.238v-.05c-.118.149-.215.192-.43.288zm0-.356c.274-.08.32-.12.43-.218v-.058c-.118.143-.215.185-.43.276zm0-.407c.274-.071.32-.108.43-.197v-.066c-.118.135-.215.175-.43.263zm0-.457v.003c.274-.064.32-.097.43-.177V30.6c-.118.126-.215.163-.43.246zm0-.503v.005c.274-.056.323-.086.43-.153v-.079c-.117.116-.215.15-.43.227zm0-.544v.005c.274-.045.322-.07.43-.126v-.085c-.117.104-.215.136-.43.206zm0-.582v.005c.273-.034.322-.054.43-.099v-.09c-.117.092-.215.12-.43.184zm0-.616v.004c.273-.022.322-.036.43-.069v-.095c-.117.079-.215.104-.43.16zm0-.648v.006c.273-.01.322-.02.43-.04v-.1c-.117.065-.215.087-.43.134zm0-.668v.006c.272.001.328-.003.43-.01v-.11c-.117.054-.215.073-.43.114zm0-.696v.007l.43.025v-.12c-.117.04-.215.056-.43.088zm0-.723v.007c.276.03.327.04.43.06v-.12c-.111.021-.206.031-.43.053zm0-.721v.006c.275.043.32.058.43.095v-.12l-.43.019zm0-.7v.007c.275.049.32.068.43.113v-.104a4.103 4.103 0 00-.43-.015zm0-.671v.005c.275.06.32.083.43.14v-.099c-.119-.03-.216-.034-.43-.046zm0-.643v.005c.274.07.32.098.43.166v-.095c-.118-.044-.216-.054-.43-.076zm0-.61v.005c.274.077.32.11.43.189v-.09c-.118-.06-.216-.073-.43-.104zm0-.575v.005c.274.086.32.123.43.211v-.083c-.118-.074-.216-.092-.43-.133zm0-.535v.005c.274.093.32.134.43.231v-.078c-.118-.087-.216-.109-.43-.158zm0-.492v.004c.274.1.32.144.43.25v-.07c-.118-.1-.216-.127-.43-.184zm0-.445c.274.11.32.156.43.269v-.064c-.118-.11-.216-.14-.43-.205zm0-.395c.274.113.32.163.43.281v-.055c-.118-.122-.216-.155-.43-.226zm0-.342c.274.117.32.168.43.292v-.047c-.118-.131-.216-.167-.43-.245zm0-.285c.274.12.32.172.43.3v-.039c-.118-.14-.216-.177-.43-.26zm0-.224c.274.12.32.174.43.304v-.029c-.118-.146-.216-.186-.43-.275zm0-.16c.274.12.32.174.43.306v-.02c-.118-.151-.216-.193-.43-.286zm.075-.059a.796.796 0 01.355.271v-.009c-.103-.136-.19-.187-.355-.262zm-.063-.012zM41.67 32.578v.011c.113.157.21.201.421.297-.27-.12-.314-.174-.421-.308zm0-.108v.021c.113.153.21.195.421.288-.27-.121-.314-.176-.421-.31zm0-.173v.032c.113.146.21.186.421.275-.27-.12-.314-.175-.421-.307zm0-.233v.041c.113.14.21.177.421.26-.27-.119-.314-.172-.421-.3zm0-.29v.05c.113.13.21.166.421.243-.27-.117-.314-.168-.421-.293zm0-.343v.057c.113.121.21.153.421.224-.27-.113-.314-.162-.421-.281zm0-.394v.065c.113.11.21.139.421.203-.27-.109-.314-.155-.421-.268zm0-.44v.072c.113.098.21.123.421.18v-.005c-.27-.099-.314-.142-.421-.247zm0-.484v.079c.113.085.21.107.421.154v-.004c-.27-.092-.314-.132-.421-.229zm0-.523v.085c.113.071.21.089.421.128v-.005c-.27-.084-.314-.12-.421-.208zm0-.56v.09c.113.058.21.071.421.1v-.004c-.27-.076-.314-.108-.421-.186zm0-.592v.096c.114.042.21.05.421.07V28.6c-.27-.066-.314-.094-.421-.16zm0-.62v.099c.114.026.21.03.421.04v-.005c-.27-.057-.314-.08-.421-.135zm0-.648v.11c.115.01.224.01.421.01v-.007c-.27-.049-.314-.068-.421-.113zm0-.67v.12l.421-.025v-.006c-.27-.04-.315-.054-.421-.088zm0-.687v.119c.107-.024.201-.036.421-.06v-.006c-.272-.027-.322-.036-.421-.053zm0-.687v.12c.112-.044.21-.06.421-.095v-.007c-.255-.012-.321-.014-.421-.018zm0-.665v.103c.112-.054.21-.073.421-.113v-.006a3.561 3.561 0 00-.421.016zm0-.64v.098c.113-.069.21-.091.421-.14v-.006a1.939 1.939 0 00-.421.047zm0-.613v.094c.113-.083.21-.109.421-.167v-.005c-.269.025-.317.042-.421.078zm0-.582v.09c.113-.096.21-.126.421-.191v-.005c-.27.036-.317.058-.421.106zm0-.546v.083c.113-.108.21-.14.421-.213v-.005c-.27.048-.317.075-.421.135zm0-.51v.078c.113-.119.21-.154.421-.233v-.004c-.27.057-.314.087-.421.16zm0-.466v.07c.113-.129.21-.167.421-.251v-.004c-.27.067-.314.102-.421.185zm0-.423v.063c.113-.137.21-.178.421-.267v-.004c-.27.077-.314.115-.421.208zm0-.374v.055c.113-.145.21-.188.421-.281-.27.082-.314.124-.421.226zm0-.323v.047c.113-.151.21-.195.421-.292-.27.09-.314.135-.421.245zm0-.269v.039c.113-.156.21-.202.421-.3-.27.097-.314.145-.421.261zm0-.21v.03c.113-.16.21-.206.421-.306-.27.104-.314.154-.421.277zm0-.148v.02c.113-.162.21-.208.421-.309-.27.11-.314.162-.421.29zm0-.083v.008c.113-.16.21-.207.421-.307-.27.114-.314.168-.421.299zm3.705-.037l.012.014a.531.531 0 00-.104-.11.973.973 0 01.041.042.732.732 0 00.015.015l.008.009a.502.502 0 01.045.055v-.004l-.017-.021zm-1.655-.342a.178.178 0 00.085-.01c.13-.042.31-.07.536-.03v-.013a1.167 1.167 0 00-.62.053zm0 .135l.029.006c.204-.067.404-.097.592-.097v-.022a1.67 1.67 0 00-.53.078l-.09.035zm.067.196c.178-.068.369-.108.554-.121v-.028c-.2.016-.411.066-.62.158a.137.137 0 00.066-.009zm-.067.298a.115.115 0 00.067-.011c.062-.03.14-.068.268-.108.1-.028.195-.048.286-.061v-.036a1.865 1.865 0 00-.227.047c-.19.06-.252.091-.394.17zm.085.324c.172-.1.356-.169.536-.208v-.042a1.907 1.907 0 00-.62.274c.025.007.06-.011.084-.024zm-.056.436a2.21 2.21 0 01.592-.286v-.05c-.204.063-.416.17-.62.328l.028.008zm0 .457c.208-.157.407-.264.592-.332v-.058a2.155 2.155 0 00-.62.38l.028.01zm0 .504c.207-.173.407-.294.592-.374v-.066c-.2.09-.41.229-.62.43l.028.01zm0 .548c.21-.19.41-.326.592-.417v-.068a2.45 2.45 0 00-.62.474l.028.011zm-.029.578l.029.012c.21-.205.41-.352.592-.454v-.075a2.635 2.635 0 00-.62.517zm0 .626l.029.012c.165-.17.195-.202.306-.29.1-.077.195-.142.286-.196v-.081a2.727 2.727 0 00-.62.555zm0 .66l.029.013c.214-.234.412-.404.592-.523v-.083a3.045 3.045 0 00-.62.593zm0 .69l.029.013a3.55 3.55 0 01.592-.552v-.086a3.155 3.155 0 00-.62.625zm0 .716l.029.013c.213-.253.412-.441.592-.579v-.087a3.37 3.37 0 00-.62.653zm0 .739l.029.014c.213-.261.411-.458.592-.602v-.091a3.6 3.6 0 00-.62.679zm0 .74l.029.014c.217-.262.415-.46.592-.607v-.095a4.006 4.006 0 00-.62.689zm0 .721l.029.013c.217-.255.415-.449.592-.595v-.094c-.191.165-.4.385-.62.676zm0 .697l.029.012c.216-.246.414-.435.592-.58v-.09a4.331 4.331 0 00-.62.658zm0 .67l.029.01c.219-.238.416-.42.592-.562v-.086c-.19.158-.4.366-.62.637zm0 .637l.029.01c.218-.225.415-.401.592-.54v-.083a4.969 4.969 0 00-.62.613zm0 .602c.009.003.02.008.029.01.217-.213.415-.382.592-.516v-.078c-.192.15-.401.34-.62.584zm.029.573c.217-.2.414-.36.592-.49v-.073c-.192.146-.4.327-.62.554.008.003.02.006.028.01zm0 .52c.136-.116.333-.283.592-.46v-.066c-.193.14-.402.31-.62.518l.028.008zm0 .474c.224-.174.415-.31.592-.426v-.063c-.282.19-.471.353-.62.481l.028.008zm-.029.417l.029.006c.333-.23.39-.269.592-.39v-.055a6.212 6.212 0 00-.62.439zm.029.376l.592-.332v-.066a8.555 8.555 0 00-.62.393c.008.001.02.009.028.005zm.592.018v-.051c-.208.108-.208.108-.62.34.013.003.037.006.62-.29zm0 .306v-.048c-.174.08-.378.174-.62.283.056.006.319-.097.62-.235zm0 .224v-.026c-.301.118-.561.204-.62.224.041.002.309-.08.62-.198zm0 .169v-.02a6.443 6.443 0 01-.62.167c.053 0 .315-.055.62-.147zm0 .104v-.012a3.252 3.252 0 01-.62.119c.175-.007.395-.045.62-.107zm.04.059c-.008 0-.016.002-.023.003.008 0 .015-.002.023-.003zm.85-14.003c-.184-.137-.46-.228-.751-.27v.008c.09.013.187.03.289.056a1.4 1.4 0 01.462.206zm-.751-.185v.018c.433.027.779.183.902.387v-.016c-.154-.235-.517-.363-.902-.389zm0 .15v.029c.406-.001.767.126.902.356v-.027c-.138-.217-.485-.361-.902-.359zm0 .223v.033c.47-.037.783.117.902.322v-.039c-.158-.252-.528-.341-.902-.316zm0 .278v.043c.402-.055.763.042.902.285v-.048c-.142-.228-.493-.34-.902-.28zm0 .34v.05c.447-.092.784.04.902.246v-.059c-.144-.23-.495-.325-.902-.238zm0 .392v.061c.444-.12.782-.003.902.202V20.5c-.13-.204-.472-.316-.902-.196zm0 .447v.067c.443-.147.78-.046.902.157V20.9c-.134-.206-.482-.292-.902-.15zm0 .493v.07c.451-.18.782-.079.902.116v-.084c-.134-.197-.477-.275-.902-.102zm0 .537v.077c.45-.204.78-.12.902.068v-.09c-.114-.163-.453-.261-.902-.055zm0 .582v.083c.454-.227.775-.172.902.015v-.097c-.123-.164-.469-.223-.902-.001zm0 .613v.085c.479-.267.802-.167.902-.029v-.103c-.118-.148-.458-.207-.902.047zm0 .653v.087c.476-.29.8-.21.902-.08v-.11c-.127-.144-.473-.162-.902.103zm0 .68v.09c.474-.31.799-.252.902-.131v-.114c-.108-.112-.453-.14-.902.156zm0 .707v.093c.47-.327.796-.293.902-.184v-.117c-.11-.102-.456-.107-.902.208zm0 .726v.098c.506-.373.814-.315.902-.235v-.121c-.097-.078-.438-.087-.902.258zm0 .733v.098c.516-.378.829-.332.902-.277v-.121c-.101-.066-.438-.052-.902.3zm0 .717v.093c.51-.372.827-.357.902-.314v-.118c-.1-.048-.443-.005-.902.339zm0 .69v.09c.591-.428.898-.35.902-.348v-.114c-.068-.02-.41.005-.902.372zm0 .664v.088c.584-.416.898-.382.902-.381v-.11c-.005 0-.352-.002-.902.403zm0 .716c.58-.405.898-.408.902-.408v-.104c-.005 0-.37.052-.902.43v.082zm0 .593c.562-.383.884-.43.902-.432v-.098c-.005 0-.368.079-.902.453v.077zm0 .554c.217-.139.471-.28.764-.404.04-.017.04-.017.138-.048v-.092c-.055.018-.409.138-.902.473v.071zm0 .513c.302-.186.57-.315.902-.47v-.084a8.03 8.03 0 00-.902.488v.066zm0 .467c.297-.167.611-.301.902-.483v-.077c-.294.18-.605.327-.902.501v.06zm0 .364v.066l.902-.505v-.068c-.054.04-.054.04-.845.475l-.057.032zm0 .423c.154-.078.339-.174.562-.29a1.74 1.74 0 00.34-.212v-.06c-.106.093-.111.098-.902.51v.052zm0 .313c.39-.185.804-.405.902-.509v-.05c-.092.092-.163.164-.902.51v.049zm0 .206v.027c.376-.15.775-.34.902-.49v-.04c-.15.166-.538.353-.902.503zm0 .185v.021c.184-.06.374-.133.535-.214.162-.081.296-.17.367-.264v-.03c-.156.192-.538.362-.902.487zm0 .122v.011c.386-.104.758-.266.902-.462v-.018c-.158.21-.531.367-.902.469zm0 .052c.139-.027.319-.072.487-.143.168-.07.324-.167.415-.297v-.006c-.183.256-.615.385-.902.446zm-1.774-14.216v.013c.184-.03.37-.02.536.031l.055.019.029-.007a1.158 1.158 0 00-.62-.056zm0 .073v.022c.162 0 .33.021.493.067l.098.03.029-.005a1.847 1.847 0 00-.62-.114zm0 .164v.026a2.027 2.027 0 01.591.139l.029-.006a1.958 1.958 0 00-.62-.16zm.334.313a2.109 2.109 0 00-.334-.08v.031a1.944 1.944 0 01.554.173l.037.018.029-.006a1.624 1.624 0 00-.286-.136zm-.334.209v.042a1.923 1.923 0 01.591.24l.029-.007a1.905 1.905 0 00-.62-.275zm0 .349v.048a2.07 2.07 0 01.591.29l.029-.009a1.987 1.987 0 00-.62-.329zm0 .402v.057c.178.065.366.166.554.307l.037.028.029-.01a2.17 2.17 0 00-.62-.382zm0 .456v.063c.179.077.367.19.554.346l.037.031.029-.01a2.217 2.217 0 00-.62-.43zm0 .507v.065c.179.087.367.214.554.383l.037.034.029-.01a2.392 2.392 0 00-.62-.472zm0 .541v.075a2.47 2.47 0 01.591.455l.029-.011a2.65 2.65 0 00-.62-.519zm0 .588v.078c.058.035.116.072.175.114.197.152.262.217.379.338l.037.039.029-.012a2.74 2.74 0 00-.62-.557zm0 .626v.083c.177.116.365.273.554.48l.037.04.029-.012a2.984 2.984 0 00-.62-.591zm0 .655v.085c.172.121.354.282.536.49l.055.064.029-.013a3.16 3.16 0 00-.62-.626zm0 .687v.089c.17.125.341.282.493.462l.098.117.029-.013a3.399 3.399 0 00-.62-.655zm0 .713v.092c.176.14.364.323.554.556l.037.047.029-.014a3.62 3.62 0 00-.62-.681zm0 .731v.098c.172.14.358.325.554.56l.037.046.029-.013a4.035 4.035 0 00-.62-.691zm0 .738v.09c.162.132.33.292.493.48l.098.116.029-.013c-.22-.29-.429-.509-.62-.673zm0 .712v.088c.159.127.326.283.493.47l.098.112.029-.012a4.364 4.364 0 00-.62-.658zm0 .69v.085c.17.136.357.308.554.523l.037.04.029-.01a4.645 4.645 0 00-.62-.639zm0 .662v.082c.172.134.358.299.554.503l.037.039.029-.011a4.997 4.997 0 00-.62-.613zm0 .631v.077c.17.127.355.285.554.48l.037.038.029-.01a4.933 4.933 0 00-.62-.585zm0 .595v.07c.167.121.347.266.536.441l.055.051.029-.009a5.458 5.458 0 00-.62-.553zm0 .557v.065a6.301 6.301 0 01.591.46l.029-.008a6.078 6.078 0 00-.62-.517zm0 .51v.064a7.452 7.452 0 01.591.425l.029-.007a5.973 5.973 0 00-.62-.482zm0 .468v.056a7.403 7.403 0 01.554.363l.037.026.029-.007a6.783 6.783 0 00-.62-.438zm0 .418v.05c.093.051.147.08.22.123l.334.2.037.023.029-.005a8.846 8.846 0 00-.62-.391zm0 .364v.044l.554.281.037.02.029-.005a17.276 17.276 0 00-.62-.34zm0 .31v.035c.154.067.33.143.535.227l.056.023.029-.003a52.56 52.56 0 01-.62-.282zm0 .245v.024c.3.113.548.189.554.19l.037.011.029-.002c-.06-.02-.32-.105-.62-.223zm0 .177v.018c.201.062.393.11.536.137l.055.01h.029a6.253 6.253 0 01-.62-.165zm0 .11v.013c.205.056.399.09.54.102l.051.004h.029a3.179 3.179 0 01-.62-.119zm-1.036-.431v.006c.178.262.62.388.899.444-.287-.062-.72-.191-.899-.45zm0-.075v.018c.15.21.528.366.899.465v-.012c-.372-.102-.744-.26-.899-.47zm0-.14v.03c.13.18.516.353.899.48v-.019c-.364-.124-.744-.294-.899-.49zm0-.202v.04c.136.167.535.35.899.493v-.027c-.365-.15-.752-.337-.899-.506zm0-.26v.05c.041.044.15.162.899.5v-.038c-.737-.346-.811-.422-.899-.513zm0-.317v.06c.074.07.087.083.899.497v-.045c-.783-.407-.79-.412-.899-.512zm.84.11c-.774-.427-.774-.427-.84-.478v.068c.084.068.28.17.489.277.107.056.249.13.41.217v-.052a7.28 7.28 0 00-.059-.033zm-.48-.693a5.606 5.606 0 01-.36-.202v.077c.287.187.602.318.899.485v-.059c-.147-.087-.32-.184-.539-.301zm-.36-.663v.085c.243.113.543.252.899.471v-.066a9.519 9.519 0 00-.899-.49zm0-.503v.092l.117.04c.2.086.466.211.782.414v-.07c-.488-.331-.844-.457-.899-.476zm0-.54v.098c.09.012.43.12.899.433v-.076c-.531-.373-.894-.454-.899-.455zm0-.575v.104c.084-.003.415.073.899.409v-.08c-.53-.38-.894-.433-.899-.433zm0-.606v.109c.114-.024.447.062.899.382v-.088c-.549-.405-.895-.404-.899-.403zm0-.634v.114c.11-.043.441.02.899.35v-.091c-.492-.367-.832-.394-.899-.373zm0-.657v.118c.135-.077.48.015.899.315v-.093c-.459-.345-.8-.388-.899-.34zm0-.678v.12c.148-.11.498-.009.899.28v-.095c-.464-.35-.803-.368-.899-.305zm0-.691v.121c.113-.105.446-.088.899.24v-.103c-.464-.347-.803-.337-.899-.258zm0-.676v.117c.13-.14.474-.107.899.186v-.095c-.446-.317-.79-.31-.899-.208zm0-.654v.114c.152-.182.516-.107.899.135v-.093c-.449-.298-.793-.269-.899-.156zm0-.627v.109c.128-.17.477-.168.899.082v-.09c-.43-.266-.774-.248-.899-.101zm0-.598v.103c.125-.18.472-.198.899.035v-.087c-.455-.257-.797-.182-.899-.05zm0-.565v.097c.144-.217.497-.215.899-.017v-.082c-.434-.223-.778-.163-.899.002zm0-.529v.091c.134-.217.488-.248.899-.066v-.08c-.45-.208-.786-.108-.899.055zm0-.489v.084c.134-.223.482-.278.899-.115v-.067c-.42-.17-.766-.103-.899.098zm0-.446v.075c.132-.226.48-.299.899-.16v-.066c-.42-.144-.767-.057-.899.15zm0-.4v.067c.13-.23.478-.32.899-.206v-.058c-.43-.122-.772-.009-.899.197zm0-.35v.058c.127-.231.476-.338.899-.25v-.049c-.408-.088-.757.008-.899.24zm0-.298v.048c.135-.245.495-.342.899-.285v-.045c-.41-.06-.76.052-.899.282zm0-.242v.039c.133-.236.482-.356.899-.325v-.03c-.41-.032-.755.081-.899.316zm0-.181v.027c.133-.236.49-.365.899-.36v-.028c-.418-.003-.764.142-.899.36zm0-.119v.016c.129-.223.486-.366.899-.392v-.019c-.422.026-.765.184-.899.395zm0-.052v.004c.139-.226.505-.369.899-.422v-.005c-.39.054-.75.198-.899.423z",
    id: "Fill-18",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.607 18.844v14.29l.126.025v-14.34a3.304 3.304 0 00-.126.025",
    id: "Fill-20",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.468 18.82v14.339l.126-.024V18.844a3.424 3.424 0 00-.126-.024",
    id: "Fill-22",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.537 18.82v14.338h.127V18.82h-.127",
    id: "Fill-24",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.708 12.51c.926-.168 1.085-3.339-.078-3.517-1.044-.161-2.528.294-2.868 1.68-.322 1.504 1.926 2.023 2.946 1.838",
    id: "Fill-26",
    fill: "#DFDFDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.314 12.692l-1.195-.146a1.771 1.771 0 01-.25.032c-.368.021-.844.022-1.347.002l2 .863.792-.75z",
    id: "Fill-28",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.347 10.583c-.393.145-.51.202-.58.155-.038-.026-.04-.076-.032-.109.124-.45 1.49-.832 2.582-.763.934.044 1.26.412 1.094.517-.043.027-.117.011-.174-.008-.691-.27-2.15-.03-2.89.208",
    id: "Fill-30",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.136 12.51c-.926-.168-1.084-3.339.078-3.517 1.044-.161 2.528.294 2.868 1.68.322 1.504-1.926 2.023-2.946 1.838",
    id: "Fill-32",
    fill: "#DFDFDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.53 12.692l1.195-.146c.079.016.162.027.251.032.367.021.844.022 1.346.002l-2 .863-.791-.75z",
    id: "Fill-34",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.497 10.583c.394.145.51.202.581.155.038-.026.04-.076.031-.109-.123-.45-1.49-.832-2.581-.763-.935.044-1.261.412-1.095.517.044.027.117.011.174-.008.692-.27 2.15-.03 2.89.208",
    id: "Fill-36",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(3.522)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.408 12.074l-1.335-2.603c-1.057-2.517-2.447-4.936-4.413-7.798a2.71 2.71 0 00-.867-.804C33.498.105 22.774 0 21.416 0 20.058 0 9.335.105 8.04.869a2.71 2.71 0 00-.867.804C5.206 4.535 3.816 6.953 2.76 9.471l-1.335 2.603C.742 13.408.03 14.528.06 16c.046 2.285.767 7.256 1.689 10.36.242.816 1.047 1.381 1.966 1.381h2.684c.382 0 .767-.025 1.146-.08l.614-.084c.38-.054.764-.082 1.148-.082h24.22c.384 0 .769.028 1.148.082l.614.085c.38.054.764.08 1.146.08h2.684c.92 0 1.724-.566 1.966-1.381.922-3.105 1.643-8.076 1.689-10.361.03-1.472-.683-2.592-1.365-3.926",
    id: "Fill-38",
    fill: "#DFDFDC",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.688 23.3l.864 2.422c.252.704.85 1.163 1.515 1.163h15.71c.665 0 1.264-.46 1.515-1.163l.865-2.421h-20.47z",
    id: "Fill-41",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.763 25.838c-.29.416-.767.674-1.285.674H17.367c-.519 0-.995-.258-1.286-.674-.138-.2-.097-.134-1.002-2.377h19.687c-.907 2.248-.865 2.18-1.003 2.377zM14.688 23.3l.148.368c.914 2.264.837 2.079.88 2.169.306.64.941 1.047 1.65 1.047h15.112c.71 0 1.345-.407 1.65-1.047.043-.09-.035.1.88-2.17l.149-.367h-20.47z",
    id: "Fill-43",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.803 26.523h-.26-15.64c-.52 0-1.001-.198-1.355-.534.331.551.94.896 1.615.896h15.38c.675 0 1.283-.345 1.614-.896a1.96 1.96 0 01-1.354.534",
    id: "Fill-45",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918 24.258h20.009c.092 0 .221-.063.23-.122h-20.47c.01.06.139.122.23.122",
    id: "Fill-47",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.157 24.251c0-.06-.135-.115-.232-.115H14.92c-.096 0-.231.055-.231.115l.001.007h20.466l.002-.007",
    id: "Fill-49",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.157 26.044c0-.06-.126-.116-.217-.116H16.765c-.09 0-.217.055-.217.116l.002.006h18.605l.002-.006",
    id: "Fill-51",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.764 26.05h18.178c.086 0 .207-.062.215-.122H16.548c.009.06.13.122.216.122",
    id: "Fill-53",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.296 26.044c0-.06-.131-.116-.226-.116H14.913c-.094 0-.225.055-.225.116l.001.006h18.606l.001-.006",
    id: "Fill-55",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.688 25.928c.008.06.134.122.224.122h18.16c.09 0 .215-.062.224-.122H14.688z",
    id: "Fill-57",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.73 26.183c-.083.46-.387.702-.877.702H7.244l.926-1.89a1.41 1.41 0 011.275-.798h3.783c.432 1.183.6 1.481.502 1.986",
    id: "Fill-59",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.175 25.541c0 .741.626 1.344 1.395 1.344.77 0 1.396-.603 1.396-1.344 0-.741-.626-1.344-1.396-1.344-.77 0-1.395.603-1.395 1.344",
    id: "Fill-61",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.966 25.99c-.063.5-.666.895-1.396.895-.731 0-1.332-.393-1.395-.893.197.407.748.7 1.395.7.648 0 1.198-.295 1.396-.703",
    id: "Fill-63",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.175 24.197c.062-.502.665-.896 1.396-.896.73 0 1.331.393 1.395.893-.198-.407-.748-.7-1.395-.7-.648 0-1.2.295-1.396.703",
    id: "Fill-65",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.035 24.645a.457.457 0 01-.465.448.457.457 0 01-.465-.448c0-.248.208-.448.465-.448s.465.2.465.448",
    id: "Fill-67",
    fill: "#6C8187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.035 24.645a.457.457 0 01-.465.448.457.457 0 01-.465-.448c0-.248.208-.448.465-.448s.465.2.465.448",
    id: "Fill-69",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.035 25.04c0 .233-.059-.382-.465-.39-.406.008-.465.623-.465.39 0-.465.208-.843.465-.843s.465.378.465.843",
    id: "Fill-71",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.938 24.472c-.045-.088-.138-.272-.367-.275-.23.003-.324.187-.368.275-.02.04-.049.094-.098.103.06.3.245.518.465.518.22 0 .406-.219.465-.518-.05-.009-.077-.062-.097-.103",
    id: "Fill-73",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.06 23.3l-.166.348c.454 1.349.629 1.688.527 2.263-.087.523-.405.8-.92.8H7.628l-.383.174h6.258c.625 0 1.046-.37 1.153-1.014.117-.66-.083-1.047-.595-2.57",
    id: "Fill-75",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.536 24.557c.242-.561.73-.909 1.276-.909H13.6l.158-.347H9.812c-.633 0-1.2.404-1.48 1.054l-1.088 2.53.366-.173.926-2.155z",
    id: "Fill-77",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.46 24.258l.297-.026-.05-.094-3.672-.002c.027.039.05.08.067.122h3.358z",
    id: "Fill-79",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.705 24.161l-.32-.025h-3.35a.8.8 0 01.102.12l3.62.002-.052-.097",
    id: "Fill-81",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.757 25.95a.63.63 0 01-.009.1h-3.713a.85.85 0 00.098-.122h3.383l.241.021",
    id: "Fill-83",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.688 25.928a1.42 1.42 0 01-.02.104l-.223.018h-3.48a.948.948 0 00.138-.122h3.585z",
    id: "Fill-85",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.114 26.183c.083.46.387.702.878.702H42.6l-.925-1.89a1.41 1.41 0 00-1.275-.798h-3.783c-.433 1.183-.6 1.481-.503 1.986",
    id: "Fill-87",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.274 24.197c-.77 0-1.395.603-1.395 1.344 0 .741.626 1.344 1.395 1.344.77 0 1.396-.603 1.396-1.344 0-.741-.626-1.344-1.396-1.344",
    id: "Fill-89",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.879 25.99c.062.5.665.895 1.396.895.73 0 1.331-.393 1.395-.893-.197.407-.748.7-1.395.7-.648 0-1.199-.295-1.396-.703",
    id: "Fill-91",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.67 24.197c-.063-.502-.665-.896-1.396-.896-.73 0-1.332.393-1.395.893.197-.407.748-.7 1.395-.7.648 0 1.199.295 1.396.703",
    id: "Fill-93",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 24.645c0 .247.207.448.464.448s.466-.2.466-.448a.457.457 0 00-.466-.448c-.257 0-.465.2-.465.448",
    id: "Fill-95",
    fill: "#6C8187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 24.645c0 .247.207.448.464.448s.466-.2.466-.448a.457.457 0 00-.466-.448c-.257 0-.465.2-.465.448",
    id: "Fill-97",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 25.04c0 .233.058-.382.464-.39.407.008.466.623.466.39 0-.465-.209-.843-.466-.843s-.465.378-.465.843",
    id: "Fill-99",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.907 24.472c.045-.088.138-.272.366-.275.23.003.324.187.369.275.02.04.048.094.098.103-.06.3-.246.518-.466.518-.22 0-.405-.219-.465-.518.05-.009.077-.062.098-.103",
    id: "Fill-101",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.784 23.3l.166.348c-.453 1.349-.628 1.688-.527 2.263.088.523.406.8.92.8h5.875l.382.174h-6.257c-.626 0-1.046-.37-1.154-1.014-.116-.66.083-1.047.595-2.57",
    id: "Fill-103",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.308 24.557c-.241-.561-.73-.909-1.276-.909h-3.786l-.159-.347h3.945c.633 0 1.2.404 1.48 1.054l1.088 2.53-.365-.173-.927-2.155z",
    id: "Fill-105",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.385 24.258l-.298-.026.051-.094 3.671-.002a.666.666 0 00-.066.122h-3.358z",
    id: "Fill-107",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.14 24.161l.32-.025h3.35a.8.8 0 00-.102.12l-3.62.002.052-.097",
    id: "Fill-109",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.087 25.95a.63.63 0 00.01.1h3.712a.845.845 0 01-.098-.122h-3.383l-.24.021",
    id: "Fill-111",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.157 25.928c.005.034.012.068.02.104l.222.018h3.48a.948.948 0 01-.137-.122h-3.585z",
    id: "Fill-113",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.968 16.872l-.973-.529c-1.735-.2-4.914-.205-7.142-.212-2.924.009-5.545.027-7.143.212l-.973.529c-.234.122-.332.366-.196.617l.002.005c.339.595.816 1.338 1.163 1.94l.003.005c.113.193.388.277.654.277h.006c5.609-.021 6.239-.025 12.967 0h.006c.266 0 .541-.084.654-.277l.003-.004c.324-.564 1.018-1.667 1.165-1.946.137-.253.038-.495-.196-.617",
    id: "Fill-115",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.968 16.872l-.973-.529c-1.735-.2-4.914-.205-7.142-.212-2.924.009-5.545.027-7.143.212l-.973.529c-.234.122-.332.366-.196.617l.002.005c.339.595.816 1.338 1.163 1.94l.003.005c.113.193.388.277.654.277h.006c5.609-.021 6.239-.025 12.967 0h.006c.266 0 .541-.084.654-.277l.003-.004c.324-.564 1.018-1.667 1.165-1.946.137-.253.038-.495-.196-.617",
    id: "Fill-117",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.968 16.872l-.973-.529c-1.735-.2-4.914-.205-7.142-.212-2.924.009-5.545.027-7.143.212l-.973.529c-.234.122-.332.366-.196.617l.002.005c.339.595.816 1.338 1.163 1.94l.003.005c.113.193.388.277.654.277h.006c5.609-.021 6.239-.025 12.967 0h.006c.266 0 .541-.084.654-.277l.003-.004c.324-.564 1.018-1.667 1.165-1.946.137-.253.038-.495-.196-.617",
    id: "Fill-119",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.165 17.261c-.147.398-.841 1.966-1.166 2.769l-.002.006c-.113.275-.388.394-.654.394h-.006c-6.729-.036-7.359-.03-12.969 0h-.006c-.266 0-.54-.12-.653-.394l-.003-.006c-.347-.858-.825-1.914-1.163-2.761 0-.003-.002-.005-.003-.008a.94.94 0 01-.056-.233.887.887 0 00.056.416l.003.007c.338.847.816 1.903 1.163 2.761l.003.006c.112.275.387.395.653.394h.006c5.61-.03 6.24-.036 12.969 0h.006c.266 0 .54-.119.654-.394l.002-.006c.325-.803 1.019-2.371 1.166-2.768a.887.887 0 00.056-.417.944.944 0 01-.056.234",
    id: "Fill-121",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.736 16.773l.974-.4c1.598-.141 4.22-.155 7.143-.162 2.228.005 5.407.009 7.142.161l.974.4c.143.058.235.149.254.255.024-.14-.076-.264-.254-.334l-.974-.401c-1.735-.152-4.914-.156-7.142-.16-2.924.006-5.545.02-7.143.16l-.974.4c-.178.071-.277.196-.254.335.019-.106.11-.197.254-.254",
    id: "Fill-123",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.231 16.884l-.85-.552c-1.598-.308-11.32-.223-12.918 0l-.85.552c-.146.094-.164.252-.097.4l.973 2.19c.073.163.286.242.487.242h11.892c.201 0 .414-.079.487-.242l.973-2.19c.068-.15.049-.306-.097-.4",
    id: "Fill-125",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.264 16.131l-.127.002v3.583h.127V16.13z",
    id: "Fill-127",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.055 16.131l-.126.001v3.584h.126V16.13z",
    id: "Fill-129",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.055 16.131l-.126.001v3.584h.126V16.13z",
    id: "Fill-131",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.055 16.131h-.126v3.585h.126V16.13z",
    id: "Fill-133",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.79 19.716h.126v-3.584h-.126v3.584z",
    id: "Fill-135",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.916 16.132h-.126v3.584h.126v-3.584z",
    id: "Fill-137",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.777 16.132h-.127v3.584h.127v-3.584z",
    id: "Fill-139",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.707 16.133l-.126-.002v3.585h.126v-3.583z",
    id: "Fill-141",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.707 16.134l-.126-.003v3.585h.126v-3.582z",
    id: "Fill-143",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.638 16.134l-.127-.003v3.585h.127v-3.582z",
    id: "Fill-145",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.638 16.136l-.127-.005v3.585h.127v-3.58z",
    id: "Fill-147",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.372 19.716c.045-.011.086-.025.126-.04V16.14l-.126-.01v3.585z",
    id: "Fill-149",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-151",
    fill: "#2F302F",
    d: "M32.303 17.924l.126-.097v-.772l-.126-.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.916 16.131h-.126v3.585h.126V16.13z",
    id: "Fill-153",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.264 16.131l-.127.002v3.583h.127V16.13z",
    id: "Fill-155",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.264 16.131l-.127.003v3.582h.127V16.13z",
    id: "Fill-157",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.333 16.131l-.126.003v3.582h.126V16.13z",
    id: "Fill-159",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.207 19.716h.126V16.13l-.126.005v3.58z",
    id: "Fill-161",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.472 16.131l-.126.008v3.43l.07.135c.018.005.038.007.056.012V16.13z",
    id: "Fill-163",
    fill: "#2F302F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-165",
    fill: "#2F302F",
    d: "M17.416 17.828l.126.096v-.897l-.126.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.366 17.088H17.479a.183.183 0 01.085-.121H32.28c.05.034.078.076.086.121",
    id: "Fill-167",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.366 17.088H17.479a.304.304 0 01.047-.027l.2-.094h14.393l.2.094a.303.303 0 01.047.027",
    id: "Fill-169",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-171",
    fill: "#818181",
    d: "M32.366 18.759l-.076.122H17.555l-.076-.122z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-173",
    fill: "#E7E7E7",
    d: "M32.366 18.759l-.076.122H17.554l-.075-.122z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-175",
    fill: "#818181",
    d: "M32.366 18.759l-.075.122H18.484l-.075-.122z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-177",
    fill: "#E7E7E7",
    d: "M32.366 18.759l-.078.122H17.557l-.078-.122z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-179",
    fill: "#818181",
    d: "M31.435 19.655l-.078.122h-13.8l-.078-.122z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-181",
    fill: "#E7E7E7",
    d: "M32.366 19.655l-.077.122H18.486l-.077-.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.244 11.65c1.514-4.084 2.659-6.086 4.315-8.496 10.351-.565 16.32-.674 26.727 0 1.713 2.5 2.823 4.478 4.314 8.496-13.72-.532-21.575-.806-35.356 0",
    id: "Fill-183",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.731 4.027c.148-.358.494-.6.883-.622 8.624-.477 13.962-.381 22.59.007.395.018.746.26.896.62l1.56 3.743a.502.502 0 01-.486.693c-9.927-.3-16.327-.33-26.511-.002a.506.506 0 01-.488-.696l1.556-3.743zm25.555-.875c-.298-.02-.593-.037-.885-.055-4.57-.282-8.291-.408-11.967-.408-4.038 0-8.019.15-13.01.418l-.865.045C9.903 5.563 8.758 7.565 7.244 11.65c6.205-.363 11.209-.507 16.086-.507 5.958 0 11.728.215 19.27.507-1.478-3.989-2.602-6.001-4.314-8.498z",
    id: "Fill-185",
    fill: "#52707B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.675 8.962l3.42-.001c.351 0 .632-.323.618-.71l-.07-1.346c-.02-.355-.286-.632-.608-.632l-3.31.001c-.332 0-.605.29-.617.655l-.046 1.339c-.01.38.268.694.613.694",
    id: "Fill-187",
    fill: "#52707B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.27 9.533c-3.182.038-6.5.14-10.235.325a2.515 2.515 0 01.671-1.166c.525-.524 1.082-.87 1.416-1.6.3-.654.383-1.451.53-2.161.1-.401.259-.764.493-1.01.286-.301.623-.336.996-.336h2.131c.374 0 .71.035.996.336.235.246.393.609.493 1.01.148.709.23 1.508.53 2.16.334.73.891 1.077 1.416 1.6.11.11.206.224.289.34.114.16.204.328.274.502",
    id: "Fill-189",
    fill: "#354C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 9.858a617.978 617.978 0 00-10.236-.322 2.536 2.536 0 01.581-.885c.523-.52 1.079-.863 1.412-1.587.298-.649.38-1.44.528-2.144.1-.398.257-.757.491-1.002.285-.298.62-.333.993-.333h2.125c.372 0 .708.035.993.333.234.245.392.604.49 1.002.148.704.231 1.496.53 2.144.332.724.888 1.067 1.41 1.587a2.488 2.488 0 01.682 1.207",
    id: "Fill-191",
    fill: "#354C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28 10.37c1.098-2.758 2.042-4.457 3.27-6.298.178-.268.475-.439.799-.456 4.777-.256 8.875-.423 13.084-.423 3.703 0 7.452.129 12.066.416.32.02.613.19.79.455 1.233 1.848 2.18 3.553 3.286 6.333a.506.506 0 01-.493.69c-7.294-.28-12.335-.449-17.751-.449-4.62 0-9.28.134-14.548.42a.506.506 0 01-.504-.689m30.006-7.215c-4.977-.322-8.94-.465-12.852-.465-4.267 0-8.474.17-13.875.465-1.655 2.41-2.802 4.412-4.314 8.496 6.204-.363 11.209-.507 16.087-.507 5.957 0 11.727.214 19.27.507-1.48-3.988-2.602-6.001-4.316-8.496",
    id: "Fill-193",
    fill: "#2B3D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.67 6.273c-.869-1.583-1.722-2.758-2.828-4.103-10.115-.546-15.916-.459-25.98 0-1.078 1.313-1.936 2.479-2.827 4.103.685-1.036 30.95-1.036 31.635 0",
    id: "Fill-195",
    fill: "#CCE2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.518 5.862l1.478-2.978c.143-.292.48-.49.858-.508 8.39-.388 13.581-.31 21.975.006.384.015.725.212.871.506l1.478 2.973c1.4.11 2.308.245 2.492.406-.865-1.579-1.716-2.751-2.817-4.096-.29-.017-.576-.031-.86-.046-4.445-.23-8.066-.333-11.641-.333-3.928 0-7.8.124-12.656.342l-.841.037c-1.077 1.313-1.932 2.48-2.82 4.102.169-.163 1.075-.3 2.483-.41",
    id: "Fill-197",
    fill: "#80A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.479 6.893c-1.76.063-3.36.155-4.652.276.058-.39.104-.785.163-1.158.085-.456.22-.868.42-1.148.245-.342.533-.382.852-.382h1.82c.32 0 .607.04.852.382.2.28.336.692.421 1.148.044.285.082.583.124.882",
    id: "Fill-199",
    fill: "#617E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.018 7.17a84.42 84.42 0 00-4.652-.277c.041-.3.08-.597.124-.882.084-.456.22-.868.42-1.148.245-.342.532-.382.851-.382h1.821c.32 0 .607.04.852.382.2.28.335.692.42 1.148.06.373.106.768.164 1.158",
    id: "Fill-201",
    fill: "#617E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4 3.825a37.3 37.3 0 00-1.464-.063l.268-1.97H24.58l.262 1.97c-.45.01-.92.031-1.467.063-.172 0-.314.203-.314.451l.059.436c.045.336.246.584.484.597 1.34.073 2.26.103 3.574.009.234-.017.431-.263.476-.595l.06-.447c0-.248-.142-.451-.314-.451",
    id: "Fill-203",
    fill: "#617E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.694 6.068a23.722 23.722 0 012.152-3.148c.174-.218.463-.357.777-.371 4.647-.209 8.634-.345 12.728-.345 3.603 0 7.25.105 11.738.34.311.015.596.154.768.37a23.72 23.72 0 012.156 3.154c.348.061.574.128.657.2-.865-1.58-1.716-2.752-2.817-4.096-4.841-.263-8.696-.38-12.502-.38-4.15 0-8.242.14-13.497.38-1.075 1.313-1.93 2.479-2.819 4.101.077-.073.304-.142.66-.205",
    id: "Fill-205",
    fill: "#617E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.878 9.439c.468-.082.954-.123 1.329-.143a14.376 14.376 0 011.869.03c.257.021.558.054.884.112a22.54 22.54 0 00-4.082.001m5.98.274a1.691 1.691 0 00-.302-.174 4.55 4.55 0 00-.89-.297 10.09 10.09 0 00-1.494-.23 15.541 15.541 0 00-2.026-.031c-.463.023-1.08.078-1.672.197-.59.114-1.163.297-1.474.527l-.012.009c-.141.028-.28.058-.414.09 2.826.036 5.832.09 9.305.158a12.653 12.653 0 00-1.02-.25",
    id: "Fill-207",
    fill: "#1C2B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.548 17.336c-2.67-1.335-5.877-2.516-9.64-2.99-.297-.038-.508.075-.594.278l6.685 3.3 3.55-.588z",
    id: "Fill-209",
    fill: "#A0BCC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.361 14.339c-.068.126-.066.293.025.483l.97 2.037c.203.426.527.789.929 1.065l5.472-.714-7.396-2.871z",
    id: "Fill-211",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-213",
    fill: "#AFCDD7",
    d: "M12.827 17.59l4.652 2.126-.988-2.689z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.244 18.018c.452.44 1.005.72 1.6.784l8.635.914-4.88-2.689-5.355.99z",
    id: "Fill-215",
    fill: "#A0BCC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.816 17.489l-.752-1.558c-.043-.088.013-.151.124-.14 3.015.322 5.918 1.025 8.857 2.143l.521 1.19-6.96-.513c-.795-.058-1.486-.491-1.79-1.122zm8.712.058c-2.654-1.03-5.84-1.94-9.58-2.306-.507-.05-.764.238-.57.642l.873 1.806c.391.811 1.28 1.368 2.303 1.443l7.925.584-.951-2.17z",
    id: "Fill-217",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.966 16.131c0 .99-.833 1.793-1.861 1.793s-1.86-.803-1.86-1.793c0-.99.832-1.792 1.86-1.792s1.86.802 1.86 1.792",
    id: "Fill-219",
    fill: "#6C8187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 15.299v.832c.04-.018.082-.034.127-.049v-.847c-.044.019-.086.04-.127.064",
    id: "Fill-221",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 15.281v.85c.04-.013.083-.025.127-.035v-.861a1.146 1.146 0 00-.127.046",
    id: "Fill-223",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 15.25v.881c.04-.005.083-.009.127-.011v-.885a1.083 1.083 0 00-.127.015",
    id: "Fill-225",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 15.319v.812a1.29 1.29 0 01.127-.065v-.831a1.278 1.278 0 00-.127.084",
    id: "Fill-227",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 15.265v.866c.04-.009.083-.017.127-.022v-.874a1.1 1.1 0 00-.127.03",
    id: "Fill-229",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 16.314v.713c.037-.045.079-.091.127-.137v-.759a1.585 1.585 0 00-.127.183",
    id: "Fill-231",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 16.912c0 .2.026.115.127-.062v-.719c-.08.238-.127.502-.127.781",
    id: "Fill-233",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 16.394v.633c.034-.051.075-.112.127-.176v-.72c-.049.082-.091.17-.127.263",
    id: "Fill-235",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.035 15.235c-.021 0-.042.003-.063.004v.892l.063-.003c.022 0 .043.002.064.003v-.892c-.022-.001-.042-.004-.064-.004",
    id: "Fill-237",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 16.268v.76c.039-.038.08-.074.127-.11v-.787a1.47 1.47 0 00-.127.137",
    id: "Fill-239",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 15.342v.79c.04-.03.081-.059.127-.085v-.812a1.352 1.352 0 00-.127.107",
    id: "Fill-241",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 16.131v.788c.046.035.088.071.126.108v-.759a1.462 1.462 0 00-.126-.137",
    id: "Fill-243",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 15.235v.812c.045.026.087.054.126.084v-.79a1.352 1.352 0 00-.126-.106",
    id: "Fill-245",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 16.131v.759c.047.046.09.092.126.137v-.713a1.593 1.593 0 00-.126-.183",
    id: "Fill-247",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 15.235v.885c.044.002.086.006.127.011v-.881a1.067 1.067 0 00-.127-.015",
    id: "Fill-249",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 16.85c.1.177.126.261.126.062 0-.28-.046-.543-.126-.78v.718z",
    id: "Fill-251",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 16.131v.72c.051.064.093.125.126.176v-.633a1.735 1.735 0 00-.126-.263",
    id: "Fill-253",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 15.235v.861c.044.01.086.022.127.035v-.85a1.15 1.15 0 00-.127-.046",
    id: "Fill-255",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 15.235v.874c.044.005.086.013.127.022v-.866a1.1 1.1 0 00-.127-.03",
    id: "Fill-257",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 15.235v.831c.044.02.086.042.126.065v-.812a1.278 1.278 0 00-.126-.084",
    id: "Fill-259",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 15.235v.847c.044.015.087.031.127.05v-.833a1.18 1.18 0 00-.127-.064",
    id: "Fill-261",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 17.048v.854c.042.008.084.016.127.022v-.897a1.93 1.93 0 00-.127.021",
    id: "Fill-263",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 17.058v.834c.041.012.083.022.127.032v-.897c-.045.01-.088.02-.127.031",
    id: "Fill-265",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 17.033v.884l.127.007v-.897a2.799 2.799 0 00-.127.006",
    id: "Fill-267",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 17.04v.87c.042.006.084.01.127.014v-.897a2.38 2.38 0 00-.127.013",
    id: "Fill-269",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 17.074v.805c.041.017.083.031.127.045v-.897c-.046.015-.088.03-.127.047",
    id: "Fill-271",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18 17.108a.967.967 0 01-.069.092v.557c.039.06.08.115.127.167v-.897l-.057.081",
    id: "Fill-273",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 17.1v.76c.04.023.083.044.127.064v-.897c-.048.023-.09.048-.127.072",
    id: "Fill-275",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 16.947c.034.062.077.121.127.179v-.197a.894.894 0 01-.127.018",
    id: "Fill-277",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 17.18v.363c.036.135.078.262.127.38v-.896a.435.435 0 01-.127.154",
    id: "Fill-279",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 17.141v.687c.04.034.082.066.127.096v-.897c-.051.04-.093.079-.127.114",
    id: "Fill-281",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.039 17.027l-.067.002v.893l.063.002.064-.002v-.893l-.06-.002",
    id: "Fill-283",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 17.027v.897c.044-.02.086-.041.126-.064v-.76a1.081 1.081 0 00-.126-.073",
    id: "Fill-285",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 17.027v.897c.044-.03.086-.062.126-.096v-.686a1.188 1.188 0 00-.126-.115",
    id: "Fill-287",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.96 17.108a2.978 2.978 0 00-.057-.08v.896c.045-.052.087-.108.126-.167V17.2a.976.976 0 01-.07-.092",
    id: "Fill-289",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 17.027v.897c.048-.12.09-.247.126-.38v-.363a.435.435 0 01-.126-.154",
    id: "Fill-291",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 17.027v.897l.127-.007v-.884a2.804 2.804 0 00-.127-.006",
    id: "Fill-293",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 16.929v.197c.05-.058.092-.117.126-.18a.9.9 0 01-.126-.017",
    id: "Fill-295",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 17.027v.897c.043-.004.085-.008.127-.014v-.87a2.399 2.399 0 00-.127-.013",
    id: "Fill-297",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 17.027v.897c.043-.014.085-.028.126-.045v-.805a1.297 1.297 0 00-.126-.047",
    id: "Fill-299",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 17.027v.897c.043-.006.085-.014.127-.022v-.854a1.916 1.916 0 00-.127-.02",
    id: "Fill-301",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 17.027v.897c.043-.01.085-.02.127-.032v-.834a1.624 1.624 0 00-.127-.03",
    id: "Fill-303",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 18.759v.093c.042.011.084.02.127.029v-.096a1.792 1.792 0 01-.127-.026",
    id: "Fill-305",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 18.759v.103c.042.008.084.014.127.019v-.104a1.749 1.749 0 01-.127-.018",
    id: "Fill-307",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 18.721v.138c.041.022.083.042.127.06v-.144a1.33 1.33 0 01-.127-.054",
    id: "Fill-309",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 16.929v.025c.036.06.078.118.127.172v-.06a1.207 1.207 0 01-.127-.137",
    id: "Fill-311",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 18.721v.125c.041.026.083.05.127.072v-.129a1.386 1.386 0 01-.127-.068",
    id: "Fill-313",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 16.929v.065c.039.047.081.09.127.132v-.084a1.349 1.349 0 01-.127-.113",
    id: "Fill-315",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.124 18.759c.03.041.064.082.1.122v-.036a1.93 1.93 0 01-.1-.086",
    id: "Fill-317",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 16.929v.09c.04.038.082.074.127.107v-.102a1.405 1.405 0 01-.127-.095",
    id: "Fill-319",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111 18.721v.108c.04.032.083.062.127.09V18.8a1.42 1.42 0 01-.127-.08",
    id: "Fill-321",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 18.768v.113c.043-.002.085-.005.127-.01v-.112a1.646 1.646 0 01-.127.009",
    id: "Fill-323",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 18.79v.128c.043-.022.085-.046.126-.072v-.125a1.378 1.378 0 01-.126.068",
    id: "Fill-325",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 17.024v.102c.044-.033.086-.07.126-.107v-.09c-.04.034-.082.066-.126.095",
    id: "Fill-327",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 18.801v.117c.044-.027.086-.057.126-.089v-.108a1.42 1.42 0 01-.126.08",
    id: "Fill-329",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 18.785v.096c.043-.008.085-.018.127-.029v-.093c-.042.01-.084.019-.127.026",
    id: "Fill-331",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 18.775v.143c.043-.017.086-.037.127-.06v-.137c-.042.02-.084.038-.127.054",
    id: "Fill-333",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.916 18.845v.036c.036-.04.07-.08.1-.122a1.92 1.92 0 01-.1.086",
    id: "Fill-335",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 17.042v.084c.045-.041.087-.085.126-.132v-.065c-.04.04-.082.078-.126.113",
    id: "Fill-337",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.903 17.066v.06c.048-.054.09-.112.126-.172v-.025c-.038.048-.08.094-.126.137",
    id: "Fill-339",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.035 18.761l-.063-.002v.12l.063.002c.022 0 .043-.002.064-.003v-.119l-.064.002",
    id: "Fill-341",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 18.777v.104c.043-.005.085-.011.127-.02v-.102a1.728 1.728 0 01-.127.018",
    id: "Fill-343",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.972 18.759v.112c.042.005.084.008.127.01v-.113a1.642 1.642 0 01-.127-.01",
    id: "Fill-345",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.099 17.816v-.681a.273.273 0 00-.127-.108v.897a.273.273 0 00.127-.108",
    id: "Fill-347",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.099 17.912v-.873a.182.182 0 00-.127 0v.873a.182.182 0 00.127 0",
    id: "Fill-349",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.223 16.15a.88.88 0 000 .858l.015.02v-.897l-.015.02",
    id: "Fill-351",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.987 17.008a.88.88 0 000-.857l-.015-.02v.896l.015-.019",
    id: "Fill-353",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.099 17.027a.273.273 0 00-.127.108v.681c.037.055.08.09.127.108v-.897z",
    id: "Fill-355",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.757 18.372c0 .742-.625 1.344-1.396 1.344-.77 0-1.395-.602-1.395-1.344 0-.743.625-1.345 1.395-1.345.771 0 1.396.602 1.396 1.345",
    id: "Fill-357",
    fill: "#6C8187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.091v.833a1.32 1.32 0 01.126-.05v-.847a1.17 1.17 0 00-.126.064",
    id: "Fill-359",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.073v.85a1.35 1.35 0 01.126-.035v-.86a1.15 1.15 0 00-.126.045",
    id: "Fill-361",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.042v.882c.04-.006.083-.01.126-.012v-.885a1.098 1.098 0 00-.126.015",
    id: "Fill-363",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.111v.813c.04-.024.082-.045.126-.065v-.832a1.262 1.262 0 00-.126.084",
    id: "Fill-365",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.057v.867c.04-.01.082-.017.126-.023v-.874a1.105 1.105 0 00-.126.03",
    id: "Fill-367",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.21v.714c.037-.046.079-.092.126-.138v-.759a1.587 1.587 0 00-.126.184",
    id: "Fill-369",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.809c0 .199.026.114.126-.063v-.719c-.08.238-.126.502-.126.782",
    id: "Fill-371",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.29v.634c.033-.052.075-.113.126-.177v-.72a1.74 1.74 0 00-.126.263",
    id: "Fill-373",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.757 17.027c-.021 0-.042.003-.063.004v.893c.02-.002.041-.003.063-.003s.042.001.063.003v-.893c-.02 0-.042-.004-.063-.004",
    id: "Fill-375",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.164v.76c.039-.037.08-.074.126-.109v-.788a1.46 1.46 0 00-.126.137",
    id: "Fill-377",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.134v.79c.04-.03.081-.058.126-.085v-.812a1.368 1.368 0 00-.126.107",
    id: "Fill-379",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.788c.046.035.088.072.126.109v-.76a1.463 1.463 0 00-.126-.137",
    id: "Fill-381",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.812c.045.027.087.055.126.085v-.79a1.329 1.329 0 00-.126-.107",
    id: "Fill-383",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.76c.048.045.09.091.126.137v-.713a1.576 1.576 0 00-.126-.184",
    id: "Fill-385",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.885c.043.003.086.006.126.012v-.882a1.05 1.05 0 00-.126-.015",
    id: "Fill-387",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.746c.1.177.126.262.126.063 0-.28-.046-.544-.126-.782v.719z",
    id: "Fill-389",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.72c.051.064.093.125.126.177v-.634a1.732 1.732 0 00-.126-.263",
    id: "Fill-391",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.861c.044.01.086.022.126.036v-.85a1.143 1.143 0 00-.126-.047",
    id: "Fill-393",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.874c.044.006.086.013.126.023v-.867a1.088 1.088 0 00-.126-.03",
    id: "Fill-395",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.832c.044.02.087.041.126.065v-.813a1.262 1.262 0 00-.126-.084",
    id: "Fill-397",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.848c.044.014.086.03.126.049v-.833a1.199 1.199 0 00-.126-.064",
    id: "Fill-399",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.048v.854c.041.008.083.016.126.022v-.897a1.913 1.913 0 00-.126.021",
    id: "Fill-401",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.058v.834c.041.012.083.022.126.032v-.897c-.045.01-.087.02-.126.031",
    id: "Fill-403",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.033v.884l.126.007v-.897a2.841 2.841 0 00-.126.006",
    id: "Fill-405",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.04v.87c.041.006.084.01.126.014v-.897a2.411 2.411 0 00-.126.013",
    id: "Fill-407",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.074v.805c.04.017.083.031.126.045v-.897c-.046.015-.088.03-.126.047",
    id: "Fill-409",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.902 17.108a.978.978 0 01-.069.092v.557c.039.06.08.115.126.167v-.897l-.057.081",
    id: "Fill-411",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.1v.76c.04.023.083.044.126.064v-.897a1.09 1.09 0 00-.126.072",
    id: "Fill-413",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.844 18.77a.677.677 0 00.104.11v-.121a.986.986 0 01-.104.01",
    id: "Fill-415",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.18v.363c.036.135.078.262.126.38v-.896a.435.435 0 01-.126.154",
    id: "Fill-417",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 17.141v.687c.04.034.082.066.126.096v-.897c-.05.04-.092.079-.126.114",
    id: "Fill-419",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.76 18.82l-.066.001v.894h.126v-.894l-.06-.001",
    id: "Fill-421",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.897a1.4 1.4 0 00.126-.064v-.76a1.083 1.083 0 00-.126-.073",
    id: "Fill-423",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.897c.044-.03.087-.062.126-.096v-.686a1.186 1.186 0 00-.126-.115",
    id: "Fill-425",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.751 17.108a2.756 2.756 0 00-.057-.08v.896c.046-.052.088-.108.126-.167V17.2a.954.954 0 01-.069-.092",
    id: "Fill-427",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.897c.048-.12.09-.247.126-.38v-.363a.434.434 0 01-.126-.154",
    id: "Fill-429",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.897l.126-.007v-.884a2.771 2.771 0 00-.126-.006",
    id: "Fill-431",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.705 18.759v.122a.678.678 0 00.104-.111.973.973 0 01-.104-.011",
    id: "Fill-433",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.897c.043-.004.085-.008.126-.014v-.87a2.418 2.418 0 00-.126-.013",
    id: "Fill-435",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.897a1.64 1.64 0 00.126-.045v-.805a1.289 1.289 0 00-.126-.047",
    id: "Fill-437",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.897c.043-.006.085-.014.126-.022v-.854a1.913 1.913 0 00-.126-.02",
    id: "Fill-439",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17.027v.897c.043-.01.085-.02.126-.032v-.834a1.591 1.591 0 00-.126-.03",
    id: "Fill-441",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 18.759v.093c.041.011.083.02.126.029v-.096a1.803 1.803 0 01-.126-.026",
    id: "Fill-443",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.759v.103a1.6 1.6 0 00.126.019v-.104a1.746 1.746 0 01-.126-.018",
    id: "Fill-445",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 18.759v.085c.041.014.083.026.126.037v-.089a1.796 1.796 0 01-.126-.033",
    id: "Fill-447",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 18.759v.015a.785.785 0 00.126.107v-.037a1.06 1.06 0 01-.126-.085",
    id: "Fill-449",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 18.759v.077c.04.016.083.031.126.045v-.08a1.77 1.77 0 01-.126-.042",
    id: "Fill-451",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 18.759v.04c.039.029.08.056.126.082v-.052a1.346 1.346 0 01-.126-.07",
    id: "Fill-453",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.864 18.759c.019.041.041.082.065.122v-.036a1.612 1.612 0 01-.065-.086",
    id: "Fill-455",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 18.759v.055c.04.024.082.046.126.067v-.063a1.552 1.552 0 01-.126-.06",
    id: "Fill-457",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.833 18.759v.067c.04.02.082.038.126.055v-.073a1.714 1.714 0 01-.126-.05",
    id: "Fill-459",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.768v.113c.043-.002.085-.005.126-.01v-.112a1.647 1.647 0 01-.126.01",
    id: "Fill-461",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.8v.08c.043-.013.086-.028.126-.044v-.077c-.04.015-.083.03-.126.042",
    id: "Fill-463",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.818v.063c.044-.021.087-.043.126-.067v-.055c-.04.02-.082.04-.126.059",
    id: "Fill-465",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.808v.073c.044-.017.086-.036.126-.055v-.067c-.04.018-.083.034-.126.05",
    id: "Fill-467",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.785v.096c.043-.008.085-.018.126-.029v-.093c-.041.01-.083.019-.126.026",
    id: "Fill-469",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.792v.089c.043-.011.085-.023.126-.037v-.085a1.816 1.816 0 01-.126.033",
    id: "Fill-471",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.724 18.845v.036c.024-.04.046-.08.066-.122a1.66 1.66 0 01-.066.086",
    id: "Fill-473",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.829v.052a1.11 1.11 0 00.126-.082v-.04c-.04.025-.081.048-.126.07",
    id: "Fill-475",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.844v.037a.777.777 0 00.126-.107v-.015c-.038.03-.08.058-.126.085",
    id: "Fill-477",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.757 18.76l-.063-.001v.12l.063.002.063-.003v-.12c-.02.002-.042.003-.063.003",
    id: "Fill-479",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.777v.104c.043-.005.085-.011.126-.02v-.102a1.76 1.76 0 01-.126.018",
    id: "Fill-481",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 18.759v.112c.041.005.084.008.126.01v-.113a1.684 1.684 0 01-.126-.01",
    id: "Fill-483",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.82 17.816v-.681a.272.272 0 00-.126-.108v.897a.273.273 0 00.126-.108",
    id: "Fill-485",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.82 17.912v-.873a.183.183 0 00-.126 0v.873a.183.183 0 00.126 0",
    id: "Fill-487",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.805 16.933c-.148.052-.148.136 0 .188l.015.005v-.197l-.015.004",
    id: "Fill-489",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.709 17.121c.148-.052.148-.136 0-.188l-.015-.004v.197l.015-.005",
    id: "Fill-491",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.82 17.027a.273.273 0 00-.126.108v.681c.037.054.08.09.126.108v-.897z",
    id: "Fill-493",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.688 19.268a.457.457 0 01-.466.448.457.457 0 01-.465-.448c0-.248.208-.448.465-.448s.466.2.466.448",
    id: "Fill-495",
    fill: "#6C8187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.735v.183a3.07 3.07 0 01.103-.01v-.187a2.61 2.61 0 00-.103.014",
    id: "Fill-497",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.732v.186l.103-.008v-.189a2.754 2.754 0 00-.103.01",
    id: "Fill-499",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.725v.193a4.73 4.73 0 01.103-.002v-.195a3.19 3.19 0 00-.103.004",
    id: "Fill-501",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.74v.178l.103-.014v-.183l-.103.019",
    id: "Fill-503",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.728v.19l.103-.005v-.192a2.992 2.992 0 00-.103.007",
    id: "Fill-505",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.762v.156c.03-.01.064-.02.103-.03v-.167a1.08 1.08 0 00-.103.04",
    id: "Fill-507",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.893c0 .043.022.025.103-.014v-.158c-.065.053-.103.11-.103.172",
    id: "Fill-509",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.779v.14c.027-.012.06-.026.103-.04v-.158a.643.643 0 00-.103.058",
    id: "Fill-511",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.688 18.721l-.052.001v.196H14.738v-.196h-.05",
    id: "Fill-513",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.751v.167a1.95 1.95 0 01.103-.024v-.173l-.103.03",
    id: "Fill-515",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.745v.173l.103-.019v-.178c-.036.008-.07.015-.103.024",
    id: "Fill-517",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.173l.103.024v-.167a1.513 1.513 0 00-.103-.03",
    id: "Fill-519",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.178c.037.006.071.013.103.02v-.174a1.89 1.89 0 00-.103-.024",
    id: "Fill-521",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.167c.039.01.073.02.103.03v-.156a1.068 1.068 0 00-.103-.04",
    id: "Fill-523",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.195c.036 0 .07 0 .103.002v-.193a3.19 3.19 0 00-.103-.004",
    id: "Fill-525",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.88c.082.038.103.056.103.013 0-.062-.038-.12-.103-.172v.158z",
    id: "Fill-527",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.158c.042.014.076.028.103.04v-.14a.637.637 0 00-.103-.058",
    id: "Fill-529",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.19l.103.007v-.186a2.78 2.78 0 00-.103-.01",
    id: "Fill-531",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.192l.103.005v-.19a3.104 3.104 0 00-.103-.007",
    id: "Fill-533",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.183l.103.014v-.178a2.347 2.347 0 00-.103-.019",
    id: "Fill-535",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.186l.103.011v-.183a2.61 2.61 0 00-.103-.014",
    id: "Fill-537",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.84v.854c.034.009.068.016.103.022v-.896a1.3 1.3 0 00-.103.02",
    id: "Fill-539",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.85v.834c.034.012.068.023.103.032v-.896l-.103.03",
    id: "Fill-541",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.826v.883c.034.004.068.006.103.007v-.896c-.036 0-.07.003-.103.006",
    id: "Fill-543",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.832v.87c.034.006.068.01.103.014v-.896c-.036.003-.07.007-.103.012",
    id: "Fill-545",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.867v.805c.033.016.067.03.103.044v-.896a.962.962 0 00-.103.047",
    id: "Fill-547",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.692 18.9a.981.981 0 01-.056.093v.557c.032.058.065.114.103.166v-.896l-.047.08",
    id: "Fill-549",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.892v.76a1.1 1.1 0 00.103.064v-.896a.866.866 0 00-.103.072",
    id: "Fill-551",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.659 18.77a.674.674 0 00.057.11v-.121a.306.306 0 01-.057.01",
    id: "Fill-553",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.755v.08a.63.63 0 00.103.083v-.197a.383.383 0 01-.103.034",
    id: "Fill-555",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.934v.686c.032.034.067.066.103.096v-.896c-.041.04-.075.078-.103.114",
    id: "Fill-557",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.69 18.82l-.054.001v.894H14.738v-.894l-.048-.001",
    id: "Fill-559",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.82v.896c.036-.02.07-.04.103-.064v-.76a.853.853 0 00-.103-.072",
    id: "Fill-561",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.82v.896c.036-.03.07-.062.103-.096v-.686a1.064 1.064 0 00-.103-.114",
    id: "Fill-563",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.683 18.9a3.26 3.26 0 00-.047-.08v.896c.037-.052.071-.108.103-.167v-.556a.957.957 0 01-.056-.092",
    id: "Fill-565",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.721v.197a.633.633 0 00.103-.083v-.08a.38.38 0 01-.103-.034",
    id: "Fill-567",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.82v.896c.035-.001.069-.003.103-.007v-.883a1.853 1.853 0 00-.103-.006",
    id: "Fill-569",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.659 18.759v.122a.684.684 0 00.057-.111.306.306 0 01-.057-.011",
    id: "Fill-571",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.82v.896a1.54 1.54 0 00.103-.013v-.871a1.652 1.652 0 00-.103-.012",
    id: "Fill-573",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.82v.896c.036-.013.07-.028.103-.044v-.805a.943.943 0 00-.103-.047",
    id: "Fill-575",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.82v.896c.035-.006.07-.013.103-.022v-.853a1.234 1.234 0 00-.103-.021",
    id: "Fill-577",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.82v.896c.035-.01.07-.02.103-.032v-.833a1.104 1.104 0 00-.103-.031",
    id: "Fill-579",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.655v.093c.034.011.068.02.103.029v-.096a1.237 1.237 0 01-.103-.026",
    id: "Fill-581",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.656v.101c.034.008.068.014.103.019v-.102a1.132 1.132 0 01-.103-.018",
    id: "Fill-583",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.655v.085c.034.014.068.026.103.037v-.089a1.3 1.3 0 01-.103-.033",
    id: "Fill-585",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.759v.015a.693.693 0 00.103.107v-.037a.866.866 0 01-.103-.085",
    id: "Fill-587",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.655v.077c.033.016.067.031.103.045v-.08a1.24 1.24 0 01-.103-.042",
    id: "Fill-589",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.759v.04a.897.897 0 00.103.082v-.052a1.05 1.05 0 01-.103-.07",
    id: "Fill-591",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.67 18.779c.01.028.023.055.036.082v-.024a1.168 1.168 0 01-.036-.058",
    id: "Fill-593",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.759v.055c.033.024.066.046.103.067v-.063a1.178 1.178 0 01-.103-.06",
    id: "Fill-595",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.759v.067c.033.02.067.038.103.055v-.073a1.254 1.254 0 01-.103-.05",
    id: "Fill-597",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.669v.102c.035-.002.069-.004.103-.009v-.101a1.225 1.225 0 01-.103.008",
    id: "Fill-599",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.697v.08c.036-.014.07-.029.103-.045v-.077c-.034.015-.067.03-.103.042",
    id: "Fill-601",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.818v.063c.036-.021.07-.043.103-.067v-.055c-.033.02-.067.04-.103.059",
    id: "Fill-603",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.808v.073c.036-.017.07-.036.103-.055v-.067a1.215 1.215 0 01-.103.05",
    id: "Fill-605",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.681v.096a1.19 1.19 0 00.103-.029v-.093c-.034.01-.068.019-.103.026",
    id: "Fill-607",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.688v.089c.035-.011.07-.023.103-.037v-.085a1.214 1.214 0 01-.103.033",
    id: "Fill-609",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.67 18.837v.024c.013-.027.025-.054.036-.083l-.037.06",
    id: "Fill-611",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.829v.052a.89.89 0 00.103-.082v-.04a1.05 1.05 0 01-.103.07",
    id: "Fill-613",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 18.844v.037a.69.69 0 00.103-.107v-.015a.884.884 0 01-.103.085",
    id: "Fill-615",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.688 19.666l-.052-.002v.102l.052.002.05-.002v-.102l-.05.002",
    id: "Fill-617",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.674v.102c.035-.005.07-.011.103-.019v-.1a1.176 1.176 0 01-.103.017",
    id: "Fill-619",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.636 19.66v.102c.034.005.068.008.103.01v-.103a1.175 1.175 0 01-.103-.008",
    id: "Fill-621",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.739 18.894v-.149a.383.383 0 00-.103-.024v.197a.381.381 0 00.103-.024",
    id: "Fill-623",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.739 18.916v-.192a.535.535 0 00-.103 0v.192a.526.526 0 00.103 0",
    id: "Fill-625",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.717 18.762c-.09.032-.09.084 0 .116l.009.003v-.122l-.01.003",
    id: "Fill-627",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.658 18.878c.09-.032.09-.084 0-.116l-.009-.003v.122l.01-.003",
    id: "Fill-629",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.739 18.721a.383.383 0 00-.103.024v.15c.03.011.066.02.103.023v-.197z",
    id: "Fill-631",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.326 15.422l.222.71h.696v-.606c0-.08-.044-.147-.103-.159-.236-.047-.471-.091-.708-.13-.096-.016-.144.068-.107.185",
    id: "Fill-633",
    fill: "#FFA12F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.314 16.131l.574.696c.05.063.112.122.181.178.05.04.175.022.175-.025v-.849h-.93z",
    id: "Fill-635",
    fill: "#D76D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.296 17.336c2.67-1.335 5.877-2.516 9.64-2.99.298-.038.509.075.595.278l-6.685 3.3-3.55-.588z",
    id: "Fill-637",
    fill: "#A0BCC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.483 14.339c.068.126.066.293-.024.483l-.97 2.037a2.722 2.722 0 01-.93 1.065l-5.472-.714 7.396-2.871z",
    id: "Fill-639",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-641",
    fill: "#AFCDD7",
    d: "M37.018 17.59l-4.652 2.126.987-2.689z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6 18.018c-.451.44-1.004.72-1.6.784l-8.634.914 4.88-2.689 5.354.99z",
    id: "Fill-643",
    fill: "#A0BCC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.238 18.611l-6.96.513.522-1.19c2.938-1.118 5.841-1.82 8.857-2.142.11-.012.166.05.124.139l-.752 1.558c-.305.63-.996 1.064-1.79 1.122zm-7.872 1.105l7.925-.584c1.023-.075 1.911-.632 2.303-1.443l.872-1.806c.195-.404-.062-.692-.57-.642-3.739.365-6.926 1.276-9.58 2.306l-.95 2.169z",
    id: "Fill-645",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.879 16.131c0 .99.833 1.793 1.86 1.793 1.028 0 1.861-.803 1.861-1.793 0-.99-.833-1.792-1.86-1.792-1.028 0-1.861.802-1.861 1.792",
    id: "Fill-647",
    fill: "#6C8187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 15.299v.832a1.315 1.315 0 00-.126-.049v-.847c.043.019.085.04.126.064",
    id: "Fill-649",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 15.281v.85a1.357 1.357 0 00-.126-.035v-.861c.043.013.085.028.126.046",
    id: "Fill-651",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 15.25v.881a1.523 1.523 0 00-.126-.011v-.885c.043.003.085.007.126.015",
    id: "Fill-653",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 15.319v.812a1.29 1.29 0 00-.126-.065v-.831c.043.025.085.053.126.084",
    id: "Fill-655",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 15.265v.866a1.433 1.433 0 00-.126-.022v-.874a1.1 1.1 0 01.126.03",
    id: "Fill-657",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 16.314v.713a1.564 1.564 0 00-.126-.137v-.759c.046.057.088.119.126.183",
    id: "Fill-659",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 16.912c0 .2-.026.115-.126-.062v-.719c.08.238.126.502.126.781",
    id: "Fill-661",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 16.394v.633a2.007 2.007 0 00-.126-.176v-.72c.048.082.09.17.126.263",
    id: "Fill-663",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 15.235c.02 0 .041.003.062.004v.892l-.063-.003-.063.003v-.892c.021-.001.042-.004.063-.004",
    id: "Fill-665",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 16.268v.76a1.375 1.375 0 00-.126-.11v-.787c.044.043.087.088.126.137",
    id: "Fill-667",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 15.342v.79a1.306 1.306 0 00-.126-.085v-.812c.044.033.086.068.126.107",
    id: "Fill-669",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 16.131v.788a1.382 1.382 0 00-.126.108v-.759c.04-.049.081-.094.126-.137",
    id: "Fill-671",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 15.235v.812a1.288 1.288 0 00-.126.084v-.79c.04-.038.082-.073.126-.106",
    id: "Fill-673",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 16.131v.759c-.048.046-.09.092-.126.137v-.713c.038-.064.08-.126.126-.183",
    id: "Fill-675",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 15.235v.885a1.553 1.553 0 00-.126.011v-.881c.042-.008.084-.012.126-.015",
    id: "Fill-677",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 16.85c-.1.177-.126.261-.126.062 0-.28.046-.543.126-.78v.718z",
    id: "Fill-679",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 16.131v.72a1.998 1.998 0 00-.126.176v-.633c.035-.093.077-.18.126-.263",
    id: "Fill-681",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 15.235v.861c-.044.01-.086.022-.126.035v-.85a1.15 1.15 0 01.126-.046",
    id: "Fill-683",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 15.235v.874a1.408 1.408 0 00-.126.022v-.866c.041-.012.083-.022.126-.03",
    id: "Fill-685",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 15.235v.831c-.045.02-.087.042-.126.065v-.812c.04-.03.082-.059.126-.084",
    id: "Fill-687",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 15.235v.847c-.044.015-.086.031-.126.05v-.833c.04-.024.083-.045.126-.064",
    id: "Fill-689",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 17.048v.854a2.094 2.094 0 01-.126.022v-.897c.045.006.086.013.126.021",
    id: "Fill-691",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 17.058v.834a1.885 1.885 0 01-.126.032v-.897c.045.01.087.02.126.031",
    id: "Fill-693",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 17.033v.884a2.41 2.41 0 01-.126.007v-.897l.126.006",
    id: "Fill-695",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 17.04v.87c-.041.006-.083.01-.126.014v-.897c.044.004.086.007.126.013",
    id: "Fill-697",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 17.074v.805c-.04.017-.083.031-.126.045v-.897c.046.015.088.03.126.047",
    id: "Fill-699",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.664 17.108c.02.03.042.062.07.092v.557c-.04.06-.081.115-.127.167v-.897l.057.081",
    id: "Fill-701",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 17.1v.76c-.04.023-.082.044-.126.064v-.897c.048.023.09.048.126.072",
    id: "Fill-703",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 16.947a1.032 1.032 0 01-.126.179v-.197c.039.008.08.015.126.018",
    id: "Fill-705",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 17.18v.363a3.123 3.123 0 01-.126.38v-.896a.435.435 0 00.126.154",
    id: "Fill-707",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 17.141v.687c-.04.034-.082.066-.126.096v-.897c.05.04.092.079.126.114",
    id: "Fill-709",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.806 17.027l.066.002v.893l-.063.002-.063-.002v-.893l.06-.002",
    id: "Fill-711",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 17.027v.897a1.426 1.426 0 01-.126-.064v-.76c.037-.025.078-.05.126-.073",
    id: "Fill-713",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 17.027v.897a1.288 1.288 0 01-.126-.096v-.686c.034-.036.075-.075.126-.115",
    id: "Fill-715",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.885 17.108c.016-.024.035-.051.057-.08v.896a1.454 1.454 0 01-.126-.167V17.2a.976.976 0 00.069-.092",
    id: "Fill-717",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 17.027v.897a3.135 3.135 0 01-.126-.38v-.363a.435.435 0 00.126-.154",
    id: "Fill-719",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 17.027v.897a2.411 2.411 0 01-.126-.007v-.884c.04-.003.082-.004.126-.006",
    id: "Fill-721",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 16.929v.197a1.034 1.034 0 01-.126-.18.9.9 0 00.126-.017",
    id: "Fill-723",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 17.027v.897a2.288 2.288 0 01-.126-.014v-.87c.04-.006.082-.01.126-.013",
    id: "Fill-725",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 17.027v.897a1.653 1.653 0 01-.126-.045v-.805c.038-.016.08-.032.126-.047",
    id: "Fill-727",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 17.027v.897a2.102 2.102 0 01-.126-.022v-.854c.04-.008.081-.015.126-.02",
    id: "Fill-729",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 17.027v.897a1.874 1.874 0 01-.126-.032v-.834c.038-.011.08-.021.126-.03",
    id: "Fill-731",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 18.759v.093c-.041.011-.083.02-.126.029v-.096c.043-.007.085-.016.126-.026",
    id: "Fill-733",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 18.759v.103a1.625 1.625 0 01-.126.019v-.104c.043-.004.085-.01.126-.018",
    id: "Fill-735",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 18.721v.138a1.23 1.23 0 01-.126.06v-.144a1.33 1.33 0 00.126-.054",
    id: "Fill-737",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 16.929v.025c-.035.06-.078.118-.126.172v-.06c.046-.043.088-.089.126-.137",
    id: "Fill-739",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 18.721v.125c-.04.026-.083.05-.126.072v-.129c.043-.02.085-.043.126-.068",
    id: "Fill-741",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 16.929v.065c-.038.047-.08.09-.126.132v-.084c.045-.035.087-.073.126-.113",
    id: "Fill-743",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.72 18.759c-.03.041-.064.082-.1.122v-.036c.035-.028.069-.057.1-.086",
    id: "Fill-745",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 16.929v.09a1.31 1.31 0 01-.126.107v-.102c.044-.03.086-.061.126-.095",
    id: "Fill-747",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.733 18.721v.108a1.32 1.32 0 01-.126.09V18.8c.043-.024.086-.05.126-.08",
    id: "Fill-749",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 18.768v.113a1.526 1.526 0 01-.126-.01v-.112c.042.005.084.007.126.009",
    id: "Fill-751",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 18.79v.128a1.297 1.297 0 01-.126-.072v-.125c.04.025.082.048.126.068",
    id: "Fill-753",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 17.024v.102a1.317 1.317 0 01-.126-.107v-.09c.04.034.082.066.126.095",
    id: "Fill-755",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 18.801v.117a1.323 1.323 0 01-.126-.089v-.108c.04.03.082.056.126.08",
    id: "Fill-757",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 18.785v.096a1.673 1.673 0 01-.126-.029v-.093c.041.01.083.019.126.026",
    id: "Fill-759",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 18.775v.143a1.236 1.236 0 01-.126-.06v-.137c.04.02.083.038.126.054",
    id: "Fill-761",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.929 18.845v.036c-.037-.04-.07-.08-.1-.122.031.03.065.058.1.086",
    id: "Fill-763",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 17.042v.084a1.229 1.229 0 01-.126-.132v-.065c.039.04.081.078.126.113",
    id: "Fill-765",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.942 17.066v.06a1.043 1.043 0 01-.126-.172v-.025c.037.048.08.094.126.137",
    id: "Fill-767",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 18.761l.062-.002v.12l-.063.002-.063-.003v-.119l.063.002",
    id: "Fill-769",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 18.777v.104a1.607 1.607 0 01-.126-.02v-.102c.042.007.084.014.126.018",
    id: "Fill-771",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 18.759v.112a1.527 1.527 0 01-.126.01v-.113c.043-.002.085-.004.126-.01",
    id: "Fill-773",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.746 17.816v-.681a.273.273 0 01.126-.108v.897a.273.273 0 01-.126-.108",
    id: "Fill-775",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.746 17.912v-.873a.182.182 0 01.126 0v.873a.182.182 0 01-.126 0",
    id: "Fill-777",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.622 16.15a.88.88 0 010 .858l-.015.02v-.897l.015.02",
    id: "Fill-779",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.858 17.008a.88.88 0 010-.857c.004-.008.01-.013.014-.02v.896l-.014-.019",
    id: "Fill-781",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.746 17.027c.046.017.09.053.126.108v.681a.273.273 0 01-.126.108v-.897z",
    id: "Fill-783",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.087 18.372c0 .742.625 1.344 1.396 1.344.77 0 1.396-.602 1.396-1.344 0-.743-.625-1.345-1.396-1.345-.77 0-1.396.602-1.396 1.345",
    id: "Fill-785",
    fill: "#6C8187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.091v.833a1.32 1.32 0 00-.126-.05v-.847c.043.019.085.04.126.064",
    id: "Fill-787",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.073v.85a1.358 1.358 0 00-.126-.035v-.86c.043.012.085.028.126.045",
    id: "Fill-789",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.042v.882a1.553 1.553 0 00-.126-.012v-.885c.043.003.085.008.126.015",
    id: "Fill-791",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.111v.813a1.309 1.309 0 00-.126-.065v-.832c.044.026.086.053.126.084",
    id: "Fill-793",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.057v.867a1.44 1.44 0 00-.126-.023v-.874c.043.008.085.018.126.03",
    id: "Fill-795",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.21v.714a1.562 1.562 0 00-.126-.138v-.759c.046.057.088.119.126.184",
    id: "Fill-797",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.809c0 .199-.026.114-.126-.063v-.719c.08.238.126.502.126.782",
    id: "Fill-799",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.29v.634a1.976 1.976 0 00-.126-.177v-.72c.049.083.091.17.126.263",
    id: "Fill-801",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.948 17.027c.022 0 .042.003.063.004v.893c-.02-.002-.041-.003-.063-.003l-.063.003v-.893c.021 0 .042-.004.063-.004",
    id: "Fill-803",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.164v.76a1.37 1.37 0 00-.126-.109v-.788c.045.043.087.088.126.137",
    id: "Fill-805",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.134v.79a1.33 1.33 0 00-.126-.085v-.812c.044.033.086.069.126.107",
    id: "Fill-807",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 17.027v.788a1.37 1.37 0 00-.126.109v-.76c.04-.048.082-.094.127-.137",
    id: "Fill-809",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 17.027v.812a1.33 1.33 0 00-.126.085v-.79a1.34 1.34 0 01.127-.107",
    id: "Fill-811",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 17.027v.76c-.047.045-.089.091-.126.137v-.713c.039-.065.08-.127.127-.184",
    id: "Fill-813",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.885a1.55 1.55 0 00-.126.012v-.882a1.05 1.05 0 01.126-.015",
    id: "Fill-815",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 17.746c-.1.177-.126.262-.126.063 0-.28.046-.544.127-.782v.719z",
    id: "Fill-817",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 17.027v.72a2.007 2.007 0 00-.126.177v-.634c.036-.093.078-.18.127-.263",
    id: "Fill-819",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.861c-.044.01-.086.022-.126.036v-.85c.041-.018.083-.034.126-.047",
    id: "Fill-821",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.874a1.4 1.4 0 00-.126.023v-.867c.042-.012.084-.022.126-.03",
    id: "Fill-823",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.832c-.044.02-.086.041-.126.065v-.813c.04-.03.083-.058.126-.084",
    id: "Fill-825",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.848a1.32 1.32 0 00-.126.049v-.833c.041-.024.083-.045.126-.064",
    id: "Fill-827",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.048v.854a2.115 2.115 0 01-.126.022v-.897c.045.006.087.013.126.021",
    id: "Fill-829",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.058v.834a1.863 1.863 0 01-.126.032v-.897c.045.01.088.02.126.031",
    id: "Fill-831",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.033v.884a2.394 2.394 0 01-.126.007v-.897l.126.006",
    id: "Fill-833",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.04v.87c-.04.006-.083.01-.126.014v-.897l.126.013",
    id: "Fill-835",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.074v.805c-.04.017-.082.031-.126.045v-.897c.046.015.088.03.126.047",
    id: "Fill-837",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.942 17.108c.02.03.043.062.07.092v.557c-.04.06-.081.115-.127.167v-.897l.057.081",
    id: "Fill-839",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.1v.76c-.04.023-.082.044-.126.064v-.897c.048.024.09.048.126.072",
    id: "Fill-841",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 18.77a.671.671 0 01-.104.11v-.121c.032.005.066.009.104.01",
    id: "Fill-843",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.18v.363a3.14 3.14 0 01-.126.38v-.896a.435.435 0 00.126.154",
    id: "Fill-845",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.141v.687c-.04.034-.081.066-.126.096v-.897c.05.04.092.079.126.114",
    id: "Fill-847",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.945 18.82l.066.001v.894h-.126v-.894l.06-.001",
    id: "Fill-849",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 17.027v.897a1.4 1.4 0 01-.126-.064v-.76a1.09 1.09 0 01.127-.073",
    id: "Fill-851",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 17.027v.897a1.277 1.277 0 01-.126-.096v-.686c.034-.036.076-.075.127-.115",
    id: "Fill-853",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.094 17.108c.016-.024.035-.051.057-.08v.896a1.441 1.441 0 01-.127-.167V17.2a.954.954 0 00.07-.092",
    id: "Fill-855",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 17.027v.897a3.13 3.13 0 01-.126-.38v-.363a.434.434 0 00.127-.154",
    id: "Fill-857",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.897a2.437 2.437 0 01-.126-.007v-.884c.04-.003.083-.004.126-.006",
    id: "Fill-859",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.14 18.759v.122a.678.678 0 01-.105-.111.97.97 0 00.104-.011",
    id: "Fill-861",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.897a2.294 2.294 0 01-.126-.014v-.87c.04-.006.082-.01.126-.013",
    id: "Fill-863",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.897a1.627 1.627 0 01-.126-.045v-.805c.038-.016.08-.032.126-.047",
    id: "Fill-865",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.897a2.077 2.077 0 01-.126-.022v-.854c.04-.008.081-.015.126-.02",
    id: "Fill-867",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 17.027v.897a1.895 1.895 0 01-.126-.032v-.834a1.6 1.6 0 01.126-.03",
    id: "Fill-869",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.759v.093c-.04.011-.083.02-.126.029v-.096c.043-.007.085-.016.126-.026",
    id: "Fill-871",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.759v.103a1.6 1.6 0 01-.126.019v-.104c.043-.004.085-.01.126-.018",
    id: "Fill-873",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.759v.085a1.676 1.676 0 01-.126.037v-.089c.043-.01.085-.02.126-.033",
    id: "Fill-875",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.759v.015a.785.785 0 01-.126.107v-.037a1.06 1.06 0 00.126-.085",
    id: "Fill-877",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.759v.077c-.04.016-.082.031-.126.045v-.08a1.77 1.77 0 00.126-.042",
    id: "Fill-879",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.759v.04c-.038.029-.08.056-.126.082v-.052c.045-.022.087-.045.126-.07",
    id: "Fill-881",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.98 18.759c-.018.041-.04.082-.064.122v-.036l.065-.086",
    id: "Fill-883",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.759v.055c-.04.024-.081.046-.126.067v-.063c.044-.018.086-.038.126-.06",
    id: "Fill-885",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.759v.067c-.04.02-.082.038-.126.055v-.073c.044-.015.086-.031.126-.05",
    id: "Fill-887",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.768v.113a1.535 1.535 0 01-.126-.01v-.112c.042.005.084.007.126.01",
    id: "Fill-889",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.8v.08a1.609 1.609 0 01-.126-.044v-.077c.041.015.083.03.126.042",
    id: "Fill-891",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 18.818v.063a1.347 1.347 0 01-.126-.067v-.055c.04.02.083.04.127.059",
    id: "Fill-893",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 18.808v.073a1.531 1.531 0 01-.126-.055v-.067c.04.018.083.034.127.05",
    id: "Fill-895",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.785v.096a1.715 1.715 0 01-.126-.029v-.093c.042.01.084.019.126.026",
    id: "Fill-897",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.792v.089a1.704 1.704 0 01-.126-.037v-.085c.041.013.083.023.126.033",
    id: "Fill-899",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.12 18.845v.036a1.377 1.377 0 01-.065-.122c.02.03.042.058.065.086",
    id: "Fill-901",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 18.829v.052a1.11 1.11 0 01-.126-.082v-.04c.04.025.082.048.127.07",
    id: "Fill-903",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15 18.844v.037a.777.777 0 01-.126-.107v-.015c.038.03.08.058.127.085",
    id: "Fill-905",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.948 18.76l.063-.001v.12l-.063.002-.063-.003v-.12l.063.003",
    id: "Fill-907",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.777v.104a1.632 1.632 0 01-.126-.02v-.102c.042.007.084.014.126.018",
    id: "Fill-909",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.011 18.759v.112a1.534 1.534 0 01-.126.01v-.113c.043-.002.085-.004.126-.01",
    id: "Fill-911",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.885 17.816v-.681a.272.272 0 01.126-.108v.897a.273.273 0 01-.126-.108",
    id: "Fill-913",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.885 17.912v-.873a.183.183 0 01.126 0v.873a.183.183 0 01-.126 0",
    id: "Fill-915",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9 16.933c.149.052.149.136 0 .188l-.015.005v-.197l.015.004",
    id: "Fill-917",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.997 17.121c-.149-.052-.149-.136 0-.188l.014-.004v.197l-.014-.005",
    id: "Fill-919",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.885 17.027c.046.017.09.053.126.108v.681a.274.274 0 01-.126.108v-.897z",
    id: "Fill-921",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.157 19.268c0 .247.208.448.465.448s.465-.2.465-.448a.457.457 0 00-.465-.448c-.257 0-.465.2-.465.448",
    id: "Fill-923",
    fill: "#6C8187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.735v.183a3.07 3.07 0 00-.102-.01v-.187l.102.014",
    id: "Fill-925",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.732v.186a3.6 3.6 0 00-.102-.008v-.189l.102.01",
    id: "Fill-927",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.725v.193a4.71 4.71 0 00-.102-.002v-.195l.102.004",
    id: "Fill-929",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.74v.178a2.811 2.811 0 00-.102-.014v-.183c.035.006.07.012.102.019",
    id: "Fill-931",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.728v.19a3.928 3.928 0 00-.102-.005v-.192l.102.007",
    id: "Fill-933",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.762v.156c-.03-.01-.064-.02-.102-.03v-.167c.037.013.07.026.102.04",
    id: "Fill-935",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.893c0 .043-.021.025-.102-.014v-.158c.065.053.102.11.102.172",
    id: "Fill-937",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.779v.14a1.428 1.428 0 00-.102-.04v-.158c.04.018.073.038.102.058",
    id: "Fill-939",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.157 18.721l.051.001v.196H35.106v-.196h.051",
    id: "Fill-941",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.751v.167a1.95 1.95 0 00-.102-.024v-.173l.102.03",
    id: "Fill-943",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.745v.173a2.398 2.398 0 00-.102-.019v-.178c.035.008.07.015.102.024",
    id: "Fill-945",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.173a1.906 1.906 0 00-.102.024v-.167l.102-.03",
    id: "Fill-947",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.178c-.036.006-.07.013-.102.02v-.174c.033-.009.067-.016.102-.024",
    id: "Fill-949",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.167c-.038.01-.072.02-.102.03v-.156c.031-.015.065-.028.102-.04",
    id: "Fill-951",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.195c-.035 0-.07 0-.102.002v-.193a3.19 3.19 0 01.102-.004",
    id: "Fill-953",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.88c-.081.038-.102.056-.102.013 0-.062.037-.12.102-.172v.158z",
    id: "Fill-955",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.158a1.428 1.428 0 00-.102.04v-.14a.626.626 0 01.102-.058",
    id: "Fill-957",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.19l-.102.007v-.186a2.78 2.78 0 01.102-.01",
    id: "Fill-959",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.192l-.102.005v-.19l.102-.007",
    id: "Fill-961",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.183l-.102.014v-.178l.102-.019",
    id: "Fill-963",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.186a3.31 3.31 0 00-.102.011v-.183a2.61 2.61 0 01.102-.014",
    id: "Fill-965",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.84v.854a1.47 1.47 0 01-.102.022v-.896c.036.006.07.013.102.02",
    id: "Fill-967",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.85v.834a1.259 1.259 0 01-.102.032v-.896l.102.03",
    id: "Fill-969",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.826v.883a1.595 1.595 0 01-.102.007v-.896c.036 0 .07.003.102.006",
    id: "Fill-971",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.832v.87a1.54 1.54 0 01-.102.014v-.896c.036.003.07.007.102.012",
    id: "Fill-973",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.867v.805c-.033.016-.067.03-.102.044v-.896c.037.014.071.03.102.047",
    id: "Fill-975",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.152 18.9a.981.981 0 00.056.093v.557a1.465 1.465 0 01-.102.166v-.896l.046.08",
    id: "Fill-977",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.892v.76a1.1 1.1 0 01-.102.064v-.896a.856.856 0 01.102.072",
    id: "Fill-979",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.186 18.77a.684.684 0 01-.058.11v-.121c.018.005.037.01.058.01",
    id: "Fill-981",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.755v.08a.63.63 0 01-.102.083v-.197c.027.014.06.026.102.034",
    id: "Fill-983",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.934v.686a1.119 1.119 0 01-.102.096v-.896c.041.04.075.078.102.114",
    id: "Fill-985",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.154 18.82l.054.001v.894H35.106v-.894l.048-.001",
    id: "Fill-987",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.82v.896a1.1 1.1 0 01-.102-.064v-.76a.853.853 0 01.102-.072",
    id: "Fill-989",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.82v.896a1.101 1.101 0 01-.102-.096v-.686c.027-.035.061-.075.102-.114",
    id: "Fill-991",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.162 18.9l.046-.08v.896a1.468 1.468 0 01-.102-.167v-.556c.022-.031.04-.063.056-.092",
    id: "Fill-993",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.721v.197a.633.633 0 01-.102-.083v-.08a.381.381 0 00.102-.034",
    id: "Fill-995",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.82v.896a1.595 1.595 0 01-.102-.007v-.883c.032-.003.067-.005.102-.006",
    id: "Fill-997",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.186 18.759v.122a.684.684 0 01-.058-.111.304.304 0 00.058-.011",
    id: "Fill-999",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.82v.896a1.551 1.551 0 01-.102-.013v-.871c.032-.005.066-.01.102-.012",
    id: "Fill-1001",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.82v.896a1.169 1.169 0 01-.102-.044v-.805a.943.943 0 01.102-.047",
    id: "Fill-1003",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.82v.896a1.472 1.472 0 01-.102-.022v-.853c.032-.008.066-.015.102-.021",
    id: "Fill-1005",
    fill: "#839AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.82v.896a1.26 1.26 0 01-.102-.032v-.833c.031-.012.066-.022.102-.031",
    id: "Fill-1007",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.655v.093a1.19 1.19 0 01-.102.029v-.096c.035-.007.069-.016.102-.026",
    id: "Fill-1009",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.656v.101a1.085 1.085 0 01-.102.019v-.102c.035-.004.069-.01.102-.018",
    id: "Fill-1011",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.655v.085a1.179 1.179 0 01-.102.037v-.089a1.3 1.3 0 00.102-.033",
    id: "Fill-1013",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.759v.015a.687.687 0 01-.102.107v-.037a.866.866 0 00.102-.085",
    id: "Fill-1015",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.655v.077a1.142 1.142 0 01-.102.045v-.08a1.24 1.24 0 00.102-.042",
    id: "Fill-1017",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.759v.04a.897.897 0 01-.102.082v-.052a1.05 1.05 0 00.102-.07",
    id: "Fill-1019",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.175 18.779c-.01.028-.023.055-.036.082v-.024l.036-.058",
    id: "Fill-1021",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.759v.055a1.048 1.048 0 01-.102.067v-.063c.036-.018.07-.038.102-.06",
    id: "Fill-1023",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.759v.067c-.032.02-.066.038-.102.055v-.073c.035-.015.07-.031.102-.05",
    id: "Fill-1025",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.669v.102a1.129 1.129 0 01-.102-.009v-.101c.034.004.068.007.102.008",
    id: "Fill-1027",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.697v.08a1.188 1.188 0 01-.102-.045v-.077c.033.015.067.03.102.042",
    id: "Fill-1029",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.818v.063a1.033 1.033 0 01-.102-.067v-.055c.032.02.066.04.102.059",
    id: "Fill-1031",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.808v.073a1.103 1.103 0 01-.102-.055v-.067c.033.018.067.034.102.05",
    id: "Fill-1033",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.681v.096a1.19 1.19 0 01-.102-.029v-.093c.033.01.067.019.102.026",
    id: "Fill-1035",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.688v.089a1.178 1.178 0 01-.102-.037v-.085c.033.013.067.024.102.033",
    id: "Fill-1037",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.175 18.837v.024a1.028 1.028 0 01-.036-.083l.036.06",
    id: "Fill-1039",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.829v.052a.9.9 0 01-.102-.082v-.04c.032.025.066.048.102.07",
    id: "Fill-1041",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 18.844v.037a.685.685 0 01-.102-.107v-.015c.03.03.065.058.102.085",
    id: "Fill-1043",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.157 19.666l.051-.002v.102l-.051.002-.051-.002v-.102l.051.002",
    id: "Fill-1045",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.674v.102a1.133 1.133 0 01-.102-.019v-.1c.034.007.067.013.102.017",
    id: "Fill-1047",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 19.66v.102a1.087 1.087 0 01-.102.01v-.103c.034-.001.069-.004.102-.008",
    id: "Fill-1049",
    fill: "#AFCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.106 18.894v-.149a.384.384 0 01.102-.024v.197a.382.382 0 01-.102-.024",
    id: "Fill-1051",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.106 18.916v-.192a.535.535 0 01.102 0v.192a.526.526 0 01-.102 0",
    id: "Fill-1053",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.128 18.762c.09.032.09.084 0 .116l-.009.003v-.122l.009.003",
    id: "Fill-1055",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.186 18.878c-.09-.032-.09-.084 0-.116l.009-.003v.122l-.009-.003",
    id: "Fill-1057",
    fill: "#D0E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.106 18.721a.383.383 0 01.102.024v.15a.383.383 0 01-.102.023v-.197z",
    id: "Fill-1059",
    fill: "#F0F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.519 15.422l-.223.71H42.6v-.606c0-.08.044-.147.104-.159.235-.047.47-.091.707-.13.096-.016.144.068.108.185",
    id: "Fill-1061",
    fill: "#FFA12F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.53 16.131l-.573.696a1.264 1.264 0 01-.182.178c-.05.04-.175.022-.175-.025v-.849h.93z",
    id: "Fill-1063",
    fill: "#D76D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.486 17.027c-.58-1.12-1.506-2.153-2.688-3.349-1.182-1.195-2.615-2.294-3.832-2.904l.401-.02c1.552.781 2.916 1.637 4.101 2.609s2.104 1.805 2.941 3.05l-.923.614z",
    id: "Fill-1065",
    fill: "#CDCDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.368 17.027c.581-1.13 1.496-2.165 2.681-3.37 1.186-1.206 2.609-2.268 3.83-2.883l-.403-.02c-1.556.788-2.91 1.605-4.099 2.584-1.189.98-2.102 1.827-2.942 3.082.155.103.779.504.933.607",
    id: "Fill-1067",
    fill: "#CDCDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.314 25.99c.366.548.977.895 1.651.895h2.642c.376 0 .754-.028 1.128-.088l.604-.093a7.19 7.19 0 011.13-.09h23.837c.378 0 .757.03 1.13.09l.604.093c.374.06.752.088 1.128.088h2.642c.674 0 1.285-.347 1.651-.896H6.314z",
    id: "Fill-1069",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-1073",
    transform: "translate(10.966)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.829 2.64a100.99 100.99 0 00-.307-.565l-.003-.005-.087-.15-.032-.05c-.021-.032-.042-.065-.064-.096-.013-.02-.027-.038-.041-.057-.02-.028-.04-.056-.062-.083l-.046-.057a3.089 3.089 0 00-.063-.075l-.05-.056a2.842 2.842 0 00-.066-.069l-.053-.052a2.953 2.953 0 00-.309-.26C27.244.787 26.036.581 24.5.428 22.49.274 20.637.162 18.86.092c-2.031-.07-3.767-.09-4.35-.09L14.463 0h-.026c-.524 0-2.458.02-4.697.1-1.683.07-3.433.178-5.32.322-1.577.156-2.817.367-3.208.652l-.008.006a3.04 3.04 0 00-.851.994c-.104.188-.205.374-.305.56C3.273 0 25.681.125 28.83 2.64",
    id: "Fill-1071",
    fill: "#F2F2F2",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.461 16.131c-.403 4.13-2.952 5.925-5.356 6.076-2.853.178-6.13.174-10.48.197h-6.477c-4.349-.023-7.626-.019-10.48-.197-2.402-.151-4.951-1.946-5.354-6.075h.01c.002.163-.007.104.949 2.274.415.925 1.322 1.52 2.332 1.603l8.987.718c.108.21.37.302.62.302h.006c5.414-.023 5.87-.028 12.336 0h.006c.248 0 .505-.088.615-.293l8.99-.726.004-.001c1.027-.084 1.935-.705 2.33-1.601l.885-2.008a.788.788 0 00.03-.076l.007-.027c.005-.016.01-.03.013-.045l.006-.033.006-.035.003-.037v-.016h.012z",
    id: "Fill-1074",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51 11.592c-.215-.538-.251-1.14-.148-1.734l-.06.004c-.104.588-.076 1.21.145 1.76.34.847.587 1.783.657 2.703l.07.014c-.068-.934-.322-1.898-.663-2.747",
    id: "Fill-1076",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.544 9.86l-.064-.002c.103.594.066 1.196-.15 1.733-.339.849-.592 1.814-.66 2.748l.07-.015c.07-.919.316-1.856.655-2.703.22-.55.253-1.173.149-1.76",
    id: "Fill-1078",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.277 17.027l.037.09-.258.168a3.442 3.442 0 01-1.553.546l-.973.093-.008-.098.973-.092a3.341 3.341 0 001.514-.532l.268-.175z",
    id: "Fill-1080",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.344 18.87l-.06-.101c.003-.003.06.102.06.102",
    id: "Fill-1082",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.498 18.87l.066-.102c-.02.035-.041.07-.064.104l-.002-.001z",
    id: "Fill-1084",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.322 17.825l-.01.099-.988-.095a3.42 3.42 0 01-1.56-.557l-.233-.155c.013-.03.026-.059.037-.09l.242.16c.46.305.986.494 1.521.544l.991.094z",
    id: "Fill-1086",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1088",
    fill: "#9A9A9A",
    d: "M17.438 18.759h-.89l.032.122h.899z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1090",
    fill: "#9A9A9A",
    d: "M32.408 18.759l-.042.122h.898l.032-.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.757 0l-.115.008c-.282.147-.542.494-.815.888l.097-.025c.295-.438.576-.82.833-.871",
    id: "Fill-1092",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.966 2.689l.178-.007c.174-.237.443-.562.752-.89l-.19.035a8.11 8.11 0 00-.74.862",
    id: "Fill-1094",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.195.008L36.087 0c.245.05.56.44.84.872l.09.024c-.258-.388-.552-.744-.822-.888",
    id: "Fill-1096",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.948 1.792c.307.329.572.652.746.89l.185.007a8.329 8.329 0 00-.733-.861l-.198-.036",
    id: "Fill-1098",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.244 16.972l-.863.154a1.963 1.963 0 01-.067-.045l.85-.152.064.033.016.01z",
    id: "Fill-1100",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.53 17.081c-.02.015-.043.03-.067.045l-.863-.155.069-.034.016-.008.846.152",
    id: "Fill-1102",
    fill: "#CDCDCD"
  }))));
}
var _default = exports["default"] = SvgFrontal;